// ////////////////////////////////////////////////////////
//
//
//    GENERATED FILE  -  DO NOT EDIT
//
//    This file is generated by generate-app-model.sh
//    the folder's recursive contents.
//
// ////////////////////////////////////////////////////////

import { upperFirst } from 'lodash';

export enum AppModelObjectType {
  tableDef = 'tableDef',
  enumDef = 'enumDef',
  fieldDef = 'fieldDef',
}

export type AppSqlTypeDef =
  | 'DATE'
  | 'INT'
  | 'NUMERIC'
  | 'TEXT'
  | 'TIMESTAMP'
  | 'UUID';

export interface AppObjectDef<T extends AppModelObjectType> {
  objectType: T | string;
}

export interface AppTableDef<T extends AppModelObjectType = AppModelObjectType.tableDef> extends AppObjectDef<T> {
  tableName: string;
  fields: ObjectMap<AppFieldDef>;
  orderedFieldNames: string[];
  primaryKey?: string;
}

export interface AppFieldDef extends AppObjectDef<AppModelObjectType.fieldDef> {
  fieldName: string;
  sqlType: string; // AppSqlTypeDef
  ownerTableName: string;
  isPrimaryKey: boolean;
  isRequired: boolean;
  hasDefault: boolean;
  referenceTableName?: string;
  referenceFieldName?: string;
}

export interface AppEnumDef extends AppTableDef<AppModelObjectType.enumDef> {
  valuesByLabel: ObjectMap<number>;
  labelsByValue: ObjectMap<string>;
}

export interface AppReferenceDef {
  primaryTableName: string;
  primaryFieldName: string;
  foreignTableName: string;
  foreignFieldName: string;
}

export const appModel = {
  "tablesByName": {
    "walpSchemaVersion": {
      "tableName": "WalpSchemaVersion",
      "objectType": "table",
      "fields": {
        "schemaVersion": {
          "fieldName": "schemaVersion",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "WalpSchemaVersion"
        }
      },
      "orderedFieldNames": [
        "schemaVersion"
      ],
      "primaryKey": "schemaVersion"
    },
    "careEnvironments": {
      "tableName": "CareEnvironments",
      "objectType": "enum",
      "fields": {
        "careEnvironmentId": {
          "fieldName": "careEnvironmentId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironments"
        },
        "careEnvironmentLabel": {
          "fieldName": "careEnvironmentLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironments"
        }
      },
      "orderedFieldNames": [
        "careEnvironmentId",
        "careEnvironmentLabel"
      ],
      "primaryKey": "careEnvironmentId",
      "valuesByLabel": {
        "Home": 2701,
        "Independent Living": 2703,
        "Assisted Living": 2704,
        "Full Care Facility": 2705
      },
      "labelsByValue": {
        "2701": "Home",
        "2703": "Independent Living",
        "2704": "Assisted Living",
        "2705": "Full Care Facility"
      }
    },
    "carePhases": {
      "tableName": "CarePhases",
      "objectType": "enum",
      "fields": {
        "carePhaseId": {
          "fieldName": "carePhaseId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CarePhases"
        },
        "carePhaseLabel": {
          "fieldName": "carePhaseLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CarePhases"
        }
      },
      "orderedFieldNames": [
        "carePhaseId",
        "carePhaseLabel"
      ],
      "primaryKey": "carePhaseId",
      "valuesByLabel": {
        "Early Care": 2801,
        "Moderate Care": 2802,
        "Full Care": 2803
      },
      "labelsByValue": {
        "2801": "Early Care",
        "2802": "Moderate Care",
        "2803": "Full Care"
      }
    },
    "clientStatuses": {
      "tableName": "ClientStatuses",
      "objectType": "enum",
      "fields": {
        "clientStatusId": {
          "fieldName": "clientStatusId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientStatuses"
        },
        "clientStatusLabel": {
          "fieldName": "clientStatusLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientStatuses"
        }
      },
      "orderedFieldNames": [
        "clientStatusId",
        "clientStatusLabel"
      ],
      "primaryKey": "clientStatusId",
      "valuesByLabel": {
        "Active": 1101,
        "Inactive": 1102,
        "Archived": 1103
      },
      "labelsByValue": {
        "1101": "Active",
        "1102": "Inactive",
        "1103": "Archived"
      }
    },
    "clientTagDefs": {
      "tableName": "ClientTagDefs",
      "objectType": "enum",
      "fields": {
        "clientTagDefId": {
          "fieldName": "clientTagDefId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientTagDefs"
        },
        "clientTagDefLabel": {
          "fieldName": "clientTagDefLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientTagDefs"
        }
      },
      "orderedFieldNames": [
        "clientTagDefId",
        "clientTagDefLabel"
      ],
      "primaryKey": "clientTagDefId",
      "valuesByLabel": {
        "Fill out the intake form": 1201,
        "Algorithms currently running": 1202,
        "Algorithms finished running": 1203,
        "Start onboarding": 1204,
        "Closing the care gap": 1205,
        "Update your care support structure": 1206,
        "Completed Plan": 1207,
        "Algorithms error": 1208,
        "Client started review": 1209,
        "Client completed review": 1210,
        "Review call scheduled": 1211,
        "Review started together": 1212,
        "Review completed together": 1213,
        "Intake form incomplete": 1214,
        "Started intake form": 1215,
        "Requested meeting": 1216,
        "Representative assigned": 1217,
        "Initial contact made": 1218
      },
      "labelsByValue": {
        "1201": "Fill out the intake form",
        "1202": "Algorithms currently running",
        "1203": "Algorithms finished running",
        "1204": "Start onboarding",
        "1205": "Closing the care gap",
        "1206": "Update your care support structure",
        "1207": "Completed Plan",
        "1208": "Algorithms error",
        "1209": "Client started review",
        "1210": "Client completed review",
        "1211": "Review call scheduled",
        "1212": "Review started together",
        "1213": "Review completed together",
        "1214": "Intake form incomplete",
        "1215": "Started intake form",
        "1216": "Requested meeting",
        "1217": "Representative assigned",
        "1218": "Initial contact made"
      }
    },
    "fundingPolicyTypes": {
      "tableName": "FundingPolicyTypes",
      "objectType": "enum",
      "fields": {
        "fundingPolicyTypeId": {
          "fieldName": "fundingPolicyTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingPolicyTypes"
        },
        "fundingPolicyTypeLabel": {
          "fieldName": "fundingPolicyTypeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingPolicyTypes"
        }
      },
      "orderedFieldNames": [
        "fundingPolicyTypeId",
        "fundingPolicyTypeLabel"
      ],
      "primaryKey": "fundingPolicyTypeId",
      "valuesByLabel": {
        "Long-term Care Insurance": 2901,
        "Life Insurance with Rider": 2902,
        "Hybrid Life Insurance": 2903,
        "Short-term Care Insurance": 2904,
        "Annuity Hybrid": 2905,
        "Joint Hybrid Asset Based": 2906,
        "Joint Hybrid Annuity Based": 2907,
        "Life with Index Account": 2908,
        "Allstate Hybrid Policy": 2909,
        "Hybrid Life IRA": 2910,
        "Joint Hybrid Life IRA": 2911,
        "Fortified Life": 2912,
        "NYL SecureCare": 2913,
        "NYL Asset Flex": 2914,
        "NYL Joint SecureCare": 2915,
        "SecureCare Three": 2916,
        "Money Guard Fixed Advantage": 2917,
        "Asset Care": 2918,
        "Care Matters Two": 2919,
        "Joint Asset Care": 2920,
        "Joint Care Matters": 2921,
        "Forecare Fixed Annuity": 2922,
        "Annuity Care Two": 2923,
        "Joint Forecare Fixed Annuity": 2924,
        "Assetcare Three": 2925,
        "Joint Assetcare Three": 2926,
        "No Lapse Guarantee Life": 2927,
        "Joint Long-term Care Insurance": 2928,
        "Thrivent Long-term Care Insurance": 2929,
        "Joint Thrivent Long-term Care Insurance": 2930,
        "NGL Essential LTC": 2931,
        "Joint NGL Essential LTC": 2932,
        "Mutual of Omaha Mutualcare": 2933,
        "Joint Mutual of Omaha Mutualcare": 2934,
        "AGIS Group Policy": 2935,
        "CareScout Care Assurance": 2936,
        "Unknown Policy Type": 2937,
        "Indexed Annuity Care": 2938
      },
      "labelsByValue": {
        "2901": "Long-term Care Insurance",
        "2902": "Life Insurance with Rider",
        "2903": "Hybrid Life Insurance",
        "2904": "Short-term Care Insurance",
        "2905": "Annuity Hybrid",
        "2906": "Joint Hybrid Asset Based",
        "2907": "Joint Hybrid Annuity Based",
        "2908": "Life with Index Account",
        "2909": "Allstate Hybrid Policy",
        "2910": "Hybrid Life IRA",
        "2911": "Joint Hybrid Life IRA",
        "2912": "Fortified Life",
        "2913": "NYL SecureCare",
        "2914": "NYL Asset Flex",
        "2915": "NYL Joint SecureCare",
        "2916": "SecureCare Three",
        "2917": "Money Guard Fixed Advantage",
        "2918": "Asset Care",
        "2919": "Care Matters Two",
        "2920": "Joint Asset Care",
        "2921": "Joint Care Matters",
        "2922": "Forecare Fixed Annuity",
        "2923": "Annuity Care Two",
        "2924": "Joint Forecare Fixed Annuity",
        "2925": "Assetcare Three",
        "2926": "Joint Assetcare Three",
        "2927": "No Lapse Guarantee Life",
        "2928": "Joint Long-term Care Insurance",
        "2929": "Thrivent Long-term Care Insurance",
        "2930": "Joint Thrivent Long-term Care Insurance",
        "2931": "NGL Essential LTC",
        "2932": "Joint NGL Essential LTC",
        "2933": "Mutual of Omaha Mutualcare",
        "2934": "Joint Mutual of Omaha Mutualcare",
        "2935": "AGIS Group Policy",
        "2936": "CareScout Care Assurance",
        "2937": "Unknown Policy Type",
        "2938": "Indexed Annuity Care"
      }
    },
    "annuityTypes": {
      "tableName": "AnnuityTypes",
      "objectType": "enum",
      "fields": {
        "annuityTypeId": {
          "fieldName": "annuityTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AnnuityTypes"
        },
        "annuityTypeLabel": {
          "fieldName": "annuityTypeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AnnuityTypes"
        }
      },
      "orderedFieldNames": [
        "annuityTypeId",
        "annuityTypeLabel"
      ],
      "primaryKey": "annuityTypeId",
      "valuesByLabel": {
        "Basic Annuity": 3001
      },
      "labelsByValue": {
        "3001": "Basic Annuity"
      }
    },
    "supportProviderContributions": {
      "tableName": "SupportProviderContributions",
      "objectType": "enum",
      "fields": {
        "supportProviderContributionId": {
          "fieldName": "supportProviderContributionId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderContributions"
        },
        "supportProviderContributionLabel": {
          "fieldName": "supportProviderContributionLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderContributions"
        }
      },
      "orderedFieldNames": [
        "supportProviderContributionId",
        "supportProviderContributionLabel"
      ],
      "primaryKey": "supportProviderContributionId",
      "valuesByLabel": {
        "Physical Caregiver": 2601,
        "Care Coordinator": 2602,
        "Financial Caregiver": 2603
      },
      "labelsByValue": {
        "2601": "Physical Caregiver",
        "2602": "Care Coordinator",
        "2603": "Financial Caregiver"
      }
    },
    "supportProviderDetailSetSources": {
      "tableName": "SupportProviderDetailSetSources",
      "objectType": "enum",
      "fields": {
        "supportProviderDetailSetSourceId": {
          "fieldName": "supportProviderDetailSetSourceId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetailSetSources"
        },
        "supportProviderDetailSetSourceLabel": {
          "fieldName": "supportProviderDetailSetSourceLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetailSetSources"
        }
      },
      "orderedFieldNames": [
        "supportProviderDetailSetSourceId",
        "supportProviderDetailSetSourceLabel"
      ],
      "primaryKey": "supportProviderDetailSetSourceId",
      "valuesByLabel": {
        "Inferences": 2101,
        "Client": 2102
      },
      "labelsByValue": {
        "2101": "Inferences",
        "2102": "Client"
      }
    },
    "supportProviderTypes": {
      "tableName": "SupportProviderTypes",
      "objectType": "enum",
      "fields": {
        "supportProviderTypeId": {
          "fieldName": "supportProviderTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderTypes"
        },
        "supportProviderTypeLabel": {
          "fieldName": "supportProviderTypeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderTypes"
        }
      },
      "orderedFieldNames": [
        "supportProviderTypeId",
        "supportProviderTypeLabel"
      ],
      "primaryKey": "supportProviderTypeId",
      "valuesByLabel": {
        "Self": 2200,
        "Professional": 2201,
        "Spouse": 2202,
        "Other": 2203,
        "Child": 2204
      },
      "labelsByValue": {
        "2200": "Self",
        "2201": "Professional",
        "2202": "Spouse",
        "2203": "Other",
        "2204": "Child"
      }
    },
    "surveyQuestionTypes": {
      "tableName": "SurveyQuestionTypes",
      "objectType": "enum",
      "fields": {
        "surveyQuestionTypeId": {
          "fieldName": "surveyQuestionTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyQuestionTypes"
        },
        "surveyQuestionTypeLabel": {
          "fieldName": "surveyQuestionTypeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyQuestionTypes"
        }
      },
      "orderedFieldNames": [
        "surveyQuestionTypeId",
        "surveyQuestionTypeLabel"
      ],
      "primaryKey": "surveyQuestionTypeId",
      "valuesByLabel": {
        "Text": 2501,
        "Date": 2502,
        "Integer": 2503,
        "Multiple Choice": 2505,
        "Many Multiple Choice": 2506,
        "Ranking": 2507,
        "Boolean": 2508,
        "Phone Number": 2509,
        "Email": 2510
      },
      "labelsByValue": {
        "2501": "Text",
        "2502": "Date",
        "2503": "Integer",
        "2505": "Multiple Choice",
        "2506": "Many Multiple Choice",
        "2507": "Ranking",
        "2508": "Boolean",
        "2509": "Phone Number",
        "2510": "Email"
      }
    },
    "surveyStatuses": {
      "tableName": "SurveyStatuses",
      "objectType": "enum",
      "fields": {
        "surveyStatusId": {
          "fieldName": "surveyStatusId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyStatuses"
        },
        "surveyStatusLabel": {
          "fieldName": "surveyStatusLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyStatuses"
        }
      },
      "orderedFieldNames": [
        "surveyStatusId",
        "surveyStatusLabel"
      ],
      "primaryKey": "surveyStatusId",
      "valuesByLabel": {
        "Incomplete": 2301,
        "Complete": 2302,
        "Abandoned": 2303
      },
      "labelsByValue": {
        "2301": "Incomplete",
        "2302": "Complete",
        "2303": "Abandoned"
      }
    },
    "surveySubmitters": {
      "tableName": "SurveySubmitters",
      "objectType": "enum",
      "fields": {
        "surveySubmitterId": {
          "fieldName": "surveySubmitterId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveySubmitters"
        },
        "surveySubmitterLabel": {
          "fieldName": "surveySubmitterLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveySubmitters"
        }
      },
      "orderedFieldNames": [
        "surveySubmitterId",
        "surveySubmitterLabel"
      ],
      "primaryKey": "surveySubmitterId",
      "valuesByLabel": {
        "Advisor": 2401,
        "Client": 2402,
        "SupportProvider": 2403
      },
      "labelsByValue": {
        "2401": "Advisor",
        "2402": "Client",
        "2403": "SupportProvider"
      }
    },
    "advisors": {
      "tableName": "Advisors",
      "objectType": "table",
      "fields": {
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "organizationName": {
          "fieldName": "organizationName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "organizationDisplayName": {
          "fieldName": "organizationDisplayName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "advisorFirstName": {
          "fieldName": "advisorFirstName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "advisorLastName": {
          "fieldName": "advisorLastName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "advisorEmail": {
          "fieldName": "advisorEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "advisorPhoneNumber": {
          "fieldName": "advisorPhoneNumber",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "advisorBusinessPhoneNumber": {
          "fieldName": "advisorBusinessPhoneNumber",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "schedulingLinkUrl": {
          "fieldName": "schedulingLinkUrl",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "schedulingLinkDisplayText": {
          "fieldName": "schedulingLinkDisplayText",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "sendClientResultsLinkSetting": {
          "fieldName": "sendClientResultsLinkSetting",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Advisors"
        },
        "advisorCognitoRef": {
          "fieldName": "advisorCognitoRef",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "auth0UserId": {
          "fieldName": "auth0UserId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Advisors"
        },
        "isAccountVerified": {
          "fieldName": "isAccountVerified",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Advisors"
        },
        "hasAgreedToTermsOfService": {
          "fieldName": "hasAgreedToTermsOfService",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Advisors"
        },
        "featureFlags": {
          "fieldName": "featureFlags",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Advisors"
        },
        "advisorCreatedDateTime": {
          "fieldName": "advisorCreatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Advisors"
        }
      },
      "orderedFieldNames": [
        "advisorId",
        "organizationName",
        "organizationDisplayName",
        "advisorFirstName",
        "advisorLastName",
        "advisorEmail",
        "advisorPhoneNumber",
        "advisorBusinessPhoneNumber",
        "schedulingLinkUrl",
        "schedulingLinkDisplayText",
        "sendClientResultsLinkSetting",
        "advisorCognitoRef",
        "auth0UserId",
        "isAccountVerified",
        "hasAgreedToTermsOfService",
        "featureFlags",
        "advisorCreatedDateTime"
      ],
      "primaryKey": "advisorId"
    },
    "stripeCustomer": {
      "tableName": "StripeCustomer",
      "objectType": "table",
      "fields": {
        "stripeCustomerId": {
          "fieldName": "stripeCustomerId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "StripeCustomer"
        },
        "customerIdRef": {
          "fieldName": "customerIdRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "StripeCustomer"
        },
        "billingEmail": {
          "fieldName": "billingEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeCustomer"
        },
        "loginEmail": {
          "fieldName": "loginEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeCustomer"
        },
        "creditBalance": {
          "fieldName": "creditBalance",
          "objectType": "field",
          "sqlType": "DECIMAL",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "StripeCustomer"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "StripeCustomer"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "StripeCustomer"
        }
      },
      "orderedFieldNames": [
        "stripeCustomerId",
        "customerIdRef",
        "billingEmail",
        "loginEmail",
        "creditBalance",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "stripeCustomerId"
    },
    "stripeSubscriptions": {
      "tableName": "StripeSubscriptions",
      "objectType": "table",
      "fields": {
        "stripeSubscriptionId": {
          "fieldName": "stripeSubscriptionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "stripeCustomerId": {
          "fieldName": "stripeCustomerId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "ownerAdvisorId": {
          "fieldName": "ownerAdvisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "totalSeats": {
          "fieldName": "totalSeats",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "StripeSubscriptions"
        },
        "stripeSubscriptionItemIdRef": {
          "fieldName": "stripeSubscriptionItemIdRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "subscriptionIdRef": {
          "fieldName": "subscriptionIdRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "subscriptionStatus": {
          "fieldName": "subscriptionStatus",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "unitPricePerSeat": {
          "fieldName": "unitPricePerSeat",
          "objectType": "field",
          "sqlType": "DECIMAL",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "billingInterval": {
          "fieldName": "billingInterval",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "trialEndDateTime": {
          "fieldName": "trialEndDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "nextBillingDateTime": {
          "fieldName": "nextBillingDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "StripeSubscriptions"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "StripeSubscriptions"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "StripeSubscriptions"
        }
      },
      "orderedFieldNames": [
        "stripeSubscriptionId",
        "stripeCustomerId",
        "ownerAdvisorId",
        "totalSeats",
        "stripeSubscriptionItemIdRef",
        "subscriptionIdRef",
        "subscriptionStatus",
        "unitPricePerSeat",
        "billingInterval",
        "trialEndDateTime",
        "nextBillingDateTime",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "stripeSubscriptionId"
    },
    "sponsorships": {
      "tableName": "Sponsorships",
      "objectType": "table",
      "fields": {
        "sponsorshipId": {
          "fieldName": "sponsorshipId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "prepaidSeatMonths": {
          "fieldName": "prepaidSeatMonths",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "seatMonthsUsed": {
          "fieldName": "seatMonthsUsed",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "sponsorshipName": {
          "fieldName": "sponsorshipName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "sponsorshipStartDate": {
          "fieldName": "sponsorshipStartDate",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "sponsorshipEndDate": {
          "fieldName": "sponsorshipEndDate",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Sponsorships"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Sponsorships"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Sponsorships"
        }
      },
      "orderedFieldNames": [
        "sponsorshipId",
        "prepaidSeatMonths",
        "seatMonthsUsed",
        "sponsorshipName",
        "sponsorshipStartDate",
        "sponsorshipEndDate",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "sponsorshipId"
    },
    "sponsorshipActivities": {
      "tableName": "SponsorshipActivities",
      "objectType": "table",
      "fields": {
        "sponsorshipActivityId": {
          "fieldName": "sponsorshipActivityId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivities"
        },
        "sponsorshipActivityTypeId": {
          "fieldName": "sponsorshipActivityTypeId",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivities"
        },
        "sponsorshipId": {
          "fieldName": "sponsorshipId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivities"
        },
        "activityThreshold": {
          "fieldName": "activityThreshold",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivities"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "SponsorshipActivities"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "SponsorshipActivities"
        }
      },
      "orderedFieldNames": [
        "sponsorshipActivityId",
        "sponsorshipActivityTypeId",
        "sponsorshipId",
        "activityThreshold",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "sponsorshipActivityId"
    },
    "sponsorshipActivityTypes": {
      "tableName": "SponsorshipActivityTypes",
      "objectType": "enum",
      "fields": {
        "sponsorshipActivityTypeId": {
          "fieldName": "sponsorshipActivityTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivityTypes"
        },
        "sponsorshipActivityTypeLabel": {
          "fieldName": "sponsorshipActivityTypeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SponsorshipActivityTypes"
        }
      },
      "orderedFieldNames": [
        "sponsorshipActivityTypeId",
        "sponsorshipActivityTypeLabel"
      ],
      "primaryKey": "sponsorshipActivityTypeId",
      "valuesByLabel": {
        "Clients Added": 4001
      },
      "labelsByValue": {
        "4001": "Clients Added"
      }
    },
    "advisorSponsorshipActivities": {
      "tableName": "AdvisorSponsorshipActivities",
      "objectType": "table",
      "fields": {
        "advisorSponsorshipActivityId": {
          "fieldName": "advisorSponsorshipActivityId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipActivities"
        },
        "sponsorshipActivityTypeId": {
          "fieldName": "sponsorshipActivityTypeId",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipActivities"
        },
        "advisorSponsorshipId": {
          "fieldName": "advisorSponsorshipId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipActivities"
        },
        "activityAmount": {
          "fieldName": "activityAmount",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipActivities"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorSponsorshipActivities"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorSponsorshipActivities"
        }
      },
      "orderedFieldNames": [
        "advisorSponsorshipActivityId",
        "sponsorshipActivityTypeId",
        "advisorSponsorshipId",
        "activityAmount",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorSponsorshipActivityId"
    },
    "advisorSponsorshipStatuses": {
      "tableName": "AdvisorSponsorshipStatuses",
      "objectType": "enum",
      "fields": {
        "advisorSponsorshipStatusId": {
          "fieldName": "advisorSponsorshipStatusId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipStatuses"
        },
        "advisorSponsorshipStatusLabel": {
          "fieldName": "advisorSponsorshipStatusLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorshipStatuses"
        }
      },
      "orderedFieldNames": [
        "advisorSponsorshipStatusId",
        "advisorSponsorshipStatusLabel"
      ],
      "primaryKey": "advisorSponsorshipStatusId",
      "valuesByLabel": {
        "ACTIVE": 4101,
        "INACTIVE": 4102,
        "INVITED": 4103
      },
      "labelsByValue": {
        "4101": "ACTIVE",
        "4102": "INACTIVE",
        "4103": "INVITED"
      }
    },
    "advisorSponsorships": {
      "tableName": "AdvisorSponsorships",
      "objectType": "table",
      "fields": {
        "advisorSponsorshipId": {
          "fieldName": "advisorSponsorshipId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorships"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorships"
        },
        "advisorSponsorshipStatus": {
          "fieldName": "advisorSponsorshipStatus",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorships",
          "referenceTableName": "AdvisorSponsorshipStatuses",
          "referenceFieldName": "advisorSponsorshipStatusId"
        },
        "sponsorshipId": {
          "fieldName": "sponsorshipId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorships"
        },
        "startDate": {
          "fieldName": "startDate",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorSponsorships"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorSponsorships"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorSponsorships"
        }
      },
      "orderedFieldNames": [
        "advisorSponsorshipId",
        "advisorId",
        "advisorSponsorshipStatus",
        "sponsorshipId",
        "startDate",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorSponsorshipId"
    },
    "advisorStripeSubscriptions": {
      "tableName": "AdvisorStripeSubscriptions",
      "objectType": "table",
      "fields": {
        "advisorStripeSubscriptionId": {
          "fieldName": "advisorStripeSubscriptionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorStripeSubscriptions"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorStripeSubscriptions"
        },
        "stripeSubscriptionId": {
          "fieldName": "stripeSubscriptionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorStripeSubscriptions"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorStripeSubscriptions"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorStripeSubscriptions"
        }
      },
      "orderedFieldNames": [
        "advisorStripeSubscriptionId",
        "advisorId",
        "stripeSubscriptionId",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorStripeSubscriptionId"
    },
    "subscriptionSeats": {
      "tableName": "SubscriptionSeats",
      "objectType": "table",
      "fields": {
        "subscriptionSeatId": {
          "fieldName": "subscriptionSeatId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats"
        },
        "stripeSubscriptionId": {
          "fieldName": "stripeSubscriptionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats",
          "referenceTableName": "StripeSubscriptions",
          "referenceFieldName": "stripeSubscriptionId"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats"
        },
        "invitedEmail": {
          "fieldName": "invitedEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats"
        },
        "assignedDateTime": {
          "fieldName": "assignedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SubscriptionSeats"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "SubscriptionSeats"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "SubscriptionSeats"
        }
      },
      "orderedFieldNames": [
        "subscriptionSeatId",
        "stripeSubscriptionId",
        "advisorId",
        "status",
        "invitedEmail",
        "assignedDateTime",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "subscriptionSeatId"
    },
    "clientAuthUsers": {
      "tableName": "ClientAuthUsers",
      "objectType": "table",
      "fields": {
        "clientAuthUserId": {
          "fieldName": "clientAuthUserId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientAuthUsers"
        },
        "auth0UserId": {
          "fieldName": "auth0UserId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientAuthUsers"
        },
        "clientEmail": {
          "fieldName": "clientEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientAuthUsers"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientAuthUsers"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientAuthUsers"
        }
      },
      "orderedFieldNames": [
        "clientAuthUserId",
        "auth0UserId",
        "clientEmail",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "clientAuthUserId"
    },
    "clients": {
      "tableName": "Clients",
      "objectType": "table",
      "fields": {
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Clients",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "clientFirstName": {
          "fieldName": "clientFirstName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "clientLastName": {
          "fieldName": "clientLastName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "clientEmail": {
          "fieldName": "clientEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "clientStatus": {
          "fieldName": "clientStatus",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Clients",
          "referenceTableName": "ClientStatuses",
          "referenceFieldName": "clientStatusId"
        },
        "lastSlideSeen": {
          "fieldName": "lastSlideSeen",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Clients"
        },
        "planProgressPercent": {
          "fieldName": "planProgressPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Clients"
        },
        "clientAddedDateTime": {
          "fieldName": "clientAddedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "partnerClientId": {
          "fieldName": "partnerClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "surveyId": {
          "fieldName": "surveyId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "intakeFormUrl": {
          "fieldName": "intakeFormUrl",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients"
        },
        "deletionEligibilityDate": {
          "fieldName": "deletionEligibilityDate",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Clients"
        }
      },
      "orderedFieldNames": [
        "clientId",
        "advisorId",
        "clientFirstName",
        "clientLastName",
        "clientEmail",
        "clientStatus",
        "lastSlideSeen",
        "planProgressPercent",
        "clientAddedDateTime",
        "partnerClientId",
        "surveyId",
        "intakeFormUrl",
        "deletionEligibilityDate"
      ],
      "primaryKey": "clientId"
    },
    "clientTags": {
      "tableName": "ClientTags",
      "objectType": "table",
      "fields": {
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientTags",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "clientTagDefId": {
          "fieldName": "clientTagDefId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientTags",
          "referenceTableName": "ClientTagDefs",
          "referenceFieldName": "clientTagDefId"
        }
      },
      "orderedFieldNames": [
        "clientId",
        "clientTagDefId"
      ]
    },
    "careEnvironmentSelections": {
      "tableName": "CareEnvironmentSelections",
      "objectType": "table",
      "fields": {
        "careEnvironmentSelectionId": {
          "fieldName": "careEnvironmentSelectionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironmentSelections"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironmentSelections",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "carePhase": {
          "fieldName": "carePhase",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironmentSelections",
          "referenceTableName": "CarePhases",
          "referenceFieldName": "carePhaseId"
        },
        "careEnvironment": {
          "fieldName": "careEnvironment",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CareEnvironmentSelections",
          "referenceTableName": "CareEnvironments",
          "referenceFieldName": "careEnvironmentId"
        }
      },
      "orderedFieldNames": [
        "careEnvironmentSelectionId",
        "clientId",
        "carePhase",
        "careEnvironment"
      ],
      "primaryKey": "careEnvironmentSelectionId"
    },
    "supportProviders": {
      "tableName": "SupportProviders",
      "objectType": "table",
      "fields": {
        "supportProviderId": {
          "fieldName": "supportProviderId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviders"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviders",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "supportProviderName": {
          "fieldName": "supportProviderName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviders"
        },
        "supportProviderCareLevel": {
          "fieldName": "supportProviderCareLevel",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviders"
        },
        "supportProviderType": {
          "fieldName": "supportProviderType",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviders",
          "referenceTableName": "SupportProviderTypes",
          "referenceFieldName": "supportProviderTypeId"
        },
        "supportProviderContribution": {
          "fieldName": "supportProviderContribution",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviders",
          "referenceTableName": "SupportProviderContributions",
          "referenceFieldName": "supportProviderContributionId"
        }
      },
      "orderedFieldNames": [
        "supportProviderId",
        "clientId",
        "supportProviderName",
        "supportProviderCareLevel",
        "supportProviderType",
        "supportProviderContribution"
      ],
      "primaryKey": "supportProviderId"
    },
    "supportProviderDetailSets": {
      "tableName": "SupportProviderDetailSets",
      "objectType": "table",
      "fields": {
        "supportProviderDetailSetId": {
          "fieldName": "supportProviderDetailSetId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetailSets"
        },
        "supportProviderDetailSetDateTime": {
          "fieldName": "supportProviderDetailSetDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "SupportProviderDetailSets"
        },
        "supportProviderDetailSetSource": {
          "fieldName": "supportProviderDetailSetSource",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetailSets",
          "referenceTableName": "SupportProviderDetailSetSources",
          "referenceFieldName": "supportProviderDetailSetSourceId"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetailSets",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "removeFamilyBurden": {
          "fieldName": "removeFamilyBurden",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "SupportProviderDetailSets"
        }
      },
      "orderedFieldNames": [
        "supportProviderDetailSetId",
        "supportProviderDetailSetDateTime",
        "supportProviderDetailSetSource",
        "clientId",
        "removeFamilyBurden"
      ],
      "primaryKey": "supportProviderDetailSetId"
    },
    "supportProviderDetails": {
      "tableName": "SupportProviderDetails",
      "objectType": "table",
      "fields": {
        "supportProviderDetailId": {
          "fieldName": "supportProviderDetailId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        },
        "supportProviderDetailSetId": {
          "fieldName": "supportProviderDetailSetId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails",
          "referenceTableName": "SupportProviderDetailSets",
          "referenceFieldName": "supportProviderDetailSetId"
        },
        "supportProviderId": {
          "fieldName": "supportProviderId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails",
          "referenceTableName": "SupportProviders",
          "referenceFieldName": "supportProviderId"
        },
        "supportProviderPhaseOneHours": {
          "fieldName": "supportProviderPhaseOneHours",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        },
        "supportProviderPhaseTwoHours": {
          "fieldName": "supportProviderPhaseTwoHours",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        },
        "supportProviderPhaseThreeHours": {
          "fieldName": "supportProviderPhaseThreeHours",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        },
        "supportProviderRateHourly": {
          "fieldName": "supportProviderRateHourly",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        },
        "supportProviderRateMonthly": {
          "fieldName": "supportProviderRateMonthly",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SupportProviderDetails"
        }
      },
      "orderedFieldNames": [
        "supportProviderDetailId",
        "supportProviderDetailSetId",
        "supportProviderId",
        "supportProviderPhaseOneHours",
        "supportProviderPhaseTwoHours",
        "supportProviderPhaseThreeHours",
        "supportProviderRateHourly",
        "supportProviderRateMonthly"
      ],
      "primaryKey": "supportProviderDetailId"
    },
    "surveyDefinitions": {
      "tableName": "SurveyDefinitions",
      "objectType": "table",
      "fields": {
        "surveyDefinitionId": {
          "fieldName": "surveyDefinitionId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyDefinitions"
        },
        "surveyDefinitionLabel": {
          "fieldName": "surveyDefinitionLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyDefinitions"
        },
        "surveySubmittedBy": {
          "fieldName": "surveySubmittedBy",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SurveyDefinitions",
          "referenceTableName": "SurveySubmitters",
          "referenceFieldName": "surveySubmitterId"
        }
      },
      "orderedFieldNames": [
        "surveyDefinitionId",
        "surveyDefinitionLabel",
        "surveySubmittedBy"
      ],
      "primaryKey": "surveyDefinitionId"
    },
    "surveyQuestions": {
      "tableName": "SurveyQuestions",
      "objectType": "questionRef",
      "fields": {
        "surveyQuestionRef": {
          "fieldName": "surveyQuestionRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyQuestions"
        },
        "surveyDefinitionId": {
          "fieldName": "surveyDefinitionId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SurveyQuestions",
          "referenceTableName": "SurveyDefinitions",
          "referenceFieldName": "surveyDefinitionId"
        },
        "surveyQuestionType": {
          "fieldName": "surveyQuestionType",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyQuestions",
          "referenceTableName": "SurveyQuestionTypes",
          "referenceFieldName": "surveyQuestionTypeId"
        }
      },
      "orderedFieldNames": [
        "surveyQuestionRef",
        "surveyDefinitionId",
        "surveyQuestionType"
      ],
      "primaryKey": "surveyQuestionRef",
      "valuesByLabel": {
        "clientMaritalStatus": "clientMaritalStatus",
        "partnerFirstName": "partnerFirstName",
        "partnerLastName": "partnerLastName",
        "householdPartnered": "householdPartnered",
        "householdHouseholdSize": "householdHouseholdSize",
        "clientBirthDate": "clientBirthDate",
        "clientGenderIdentity": "clientGenderIdentity",
        "clientGenderAtBirth": "clientGenderAtBirth",
        "clientRace": "clientRace",
        "clientZipCode": "clientZipCode",
        "clientCensusRegion": "clientCensusRegion",
        "clientHighestDegree": "clientHighestDegree",
        "clientLivingSiblingsCount": "clientLivingSiblingsCount",
        "householdLivingChildrenCount": "householdLivingChildrenCount",
        "householdPriorYearIncome": "householdPriorYearIncome",
        "householdTotalAssetsValue": "householdTotalAssetsValue",
        "financialAssetTypes": "financialAssetTypes",
        "legalDocuments": "legalDocuments",
        "clientHealthPlanList": "clientHealthPlanList",
        "clientIndependencePreference": "clientIndependencePreference",
        "clientFinancialSecurityPreference": "clientFinancialSecurityPreference",
        "clientFamilyInvolvementPreference": "clientFamilyInvolvementPreference",
        "clientMentalHealthIssuesList": "clientMentalHealthIssuesList",
        "clientSmokerEver": "clientSmokerEver",
        "clientSmokedRecently": "clientSmokedRecently",
        "clientUsesRegularPrescriptionDrugs": "clientUsesRegularPrescriptionDrugs",
        "clientWeightPounds": "clientWeightPounds",
        "clientHeightInches": "clientHeightInches",
        "clientPriorTwoYearHospitalizationCount": "clientPriorTwoYearHospitalizationCount",
        "clientActivitiesWithDifficultyList": "clientActivitiesWithDifficultyList",
        "clientActivitiesReceivedAssistanceList": "clientActivitiesReceivedAssistanceList",
        "clientAgeReceivedHelpBathing": "clientAgeReceivedHelpBathing",
        "clientAgeReceivedHelpEating": "clientAgeReceivedHelpEating",
        "clientAgeReceivedHelpDressing": "clientAgeReceivedHelpDressing",
        "clientAgeReceivedHelpWalking": "clientAgeReceivedHelpWalking",
        "clientAgeReceivedHelpAccessingBed": "clientAgeReceivedHelpAccessingBed",
        "clientAgeReceivedHelpToileting": "clientAgeReceivedHelpToileting",
        "clientDiagnosesList": "clientDiagnosesList",
        "clientInjuriesList": "clientInjuriesList",
        "clientCanAnswerForFather": "clientCanAnswerForFather",
        "clientFatherIsAlive": "clientFatherIsAlive",
        "clientFatherAgeAtSurveyDate": "clientFatherAgeAtSurveyDate",
        "clientFatherAgeOfDeathAtSurveyDate": "clientFatherAgeOfDeathAtSurveyDate",
        "clientFatherRequiredAssistance": "clientFatherRequiredAssistance",
        "clientFatherAssistanceDurationMonthCount": "clientFatherAssistanceDurationMonthCount",
        "clientFatherNursingHomeEver": "clientFatherNursingHomeEver",
        "clientFatherNursingHomeMonthCount": "clientFatherNursingHomeMonthCount",
        "clientFatherCardiovascularEver": "clientFatherCardiovascularEver",
        "clientFatherMemoryProblemsEver": "clientFatherMemoryProblemsEver",
        "clientFatherMemoryDiagnosesList": "clientFatherMemoryDiagnosesList",
        "clientCanAnswerForMother": "clientCanAnswerForMother",
        "clientMotherIsAlive": "clientMotherIsAlive",
        "clientMotherAgeAtSurveyDate": "clientMotherAgeAtSurveyDate",
        "clientMotherAgeOfDeathAtSurveyDate": "clientMotherAgeOfDeathAtSurveyDate",
        "clientMotherRequiredAssistance": "clientMotherRequiredAssistance",
        "clientMotherAssistanceDurationMonthCount": "clientMotherAssistanceDurationMonthCount",
        "clientMotherNursingHomeEver": "clientMotherNursingHomeEver",
        "clientMotherNursingHomeMonthCount": "clientMotherNursingHomeMonthCount",
        "clientMotherCardiovascularEver": "clientMotherCardiovascularEver",
        "clientMotherMemoryProblemsEver": "clientMotherMemoryProblemsEver",
        "clientMotherMemoryDiagnosesList": "clientMotherMemoryDiagnosesList",
        "clientHospitalizedERLastTwelveMonths": "clientHospitalizedERLastTwelveMonths",
        "clientMedicationIntake": "clientMedicationIntake",
        "clientTherapyTypes": "clientTherapyTypes",
        "clientMarijuanaLastFiveYears": "clientMarijuanaLastFiveYears",
        "clientHardDrugsLastFiveYears": "clientHardDrugsLastFiveYears",
        "clientAssistiveDevicesList": "clientAssistiveDevicesList",
        "clientSubstancesUsed": "clientSubstancesUsed",
        "clientWeightGainedLost": "clientWeightGainedLost",
        "clientWeightGainedLastTwelveMonths": "clientWeightGainedLastTwelveMonths",
        "clientWeightLostLastTwelveMonths": "clientWeightLostLastTwelveMonths",
        "clientHospitalizationReason": "clientHospitalizationReason",
        "clientBloodPressureReading": "clientBloodPressureReading",
        "clientHeartConditionDiagnosis": "clientHeartConditionDiagnosis",
        "clientDiabetesTypeDiagnosisList": "clientDiabetesTypeDiagnosisList",
        "clientLastA1CReading": "clientLastA1CReading",
        "clientMetabolicDisordersList": "clientMetabolicDisordersList",
        "clientLungRespiratoryDiagnosis": "clientLungRespiratoryDiagnosis",
        "clientDigestiveDiagnosis": "clientDigestiveDiagnosis",
        "clientBrainInjuryDiagnosis": "clientBrainInjuryDiagnosis",
        "clientCognitiveMemoryDiagnosis": "clientCognitiveMemoryDiagnosis",
        "clientPsychiatricDiagnosis": "clientPsychiatricDiagnosis",
        "clientCancerTypeLocation": "clientCancerTypeLocation",
        "clientEENTDiagnosis": "clientEENTDiagnosis",
        "clientGenitourinaryDiagnosis": "clientGenitourinaryDiagnosis",
        "clientImmuneSystemDiagnosis": "clientImmuneSystemDiagnosis",
        "clientDisabilityWorkersComp": "clientDisabilityWorkersComp",
        "clientCigaretteLastFiveYears": "clientCigaretteLastFiveYears",
        "clientCigarPipeLastFiveYears": "clientCigarPipeLastFiveYears",
        "clientVapeLastFiveYears": "clientVapeLastFiveYears",
        "clientChewTobaccoLastFiveYears": "clientChewTobaccoLastFiveYears",
        "clientAlcoholLastFiveYears": "clientAlcoholLastFiveYears",
        "clientMedicaidProgramName": "clientMedicaidProgramName",
        "clientInjuryArthritis": "clientInjuryArthritis",
        "financialSecurityPreference": "financialSecurityPreference",
        "independenceandQualityofLifePreference": "independenceandQualityofLifePreference",
        "careEnvironmentPreference": "careEnvironmentPreference",
        "familyInvolvementPreference": "familyInvolvementPreference",
        "riskAssessmentPreference": "riskAssessmentPreference",
        "flexibilityPreference": "flexibilityPreference",
        "costEffectivenessPreference": "costEffectivenessPreference",
        "clientOwnPersonalityPerceptions": "clientOwnPersonalityPerceptions",
        "stressManagementPreference": "stressManagementPreference",
        "disagreementResolutionPreference": "disagreementResolutionPreference",
        "supportProviderInvolvement": "supportProviderInvolvement",
        "rankedFactors": "rankedFactors",
        "incentiveToAcceptCare": "incentiveToAcceptCare",
        "willingnessToAcceptCare": "willingnessToAcceptCare",
        "trustLevel": "trustLevel",
        "currentCommunnicationFrequency": "currentCommunnicationFrequency",
        "emotionalCloseness": "emotionalCloseness",
        "rolePreference": "rolePreference",
        "willingnessToReceiveCare": "willingnessToReceiveCare",
        "clientFinancialStability": "clientFinancialStability",
        "previousExperience": "previousExperience",
        "potentialSupportProvider": "potentialSupportProvider",
        "relationshipCloseness": "relationshipCloseness",
        "relationshipChangeComfortLevel": "relationshipChangeComfortLevel",
        "financialNeedConcernLevel": "financialNeedConcernLevel",
        "receivingCareInterferenceLikelihood": "receivingCareInterferenceLikelihood",
        "physicalStressLevel": "physicalStressLevel",
        "emotionalStressLevel": "emotionalStressLevel",
        "preferredSupportServices": "preferredSupportServices",
        "endOfLifeComfortLevel": "endOfLifeComfortLevel",
        "clientDecisionMakingInvolvement": "clientDecisionMakingInvolvement",
        "setbackImpactLevel": "setbackImpactLevel",
        "clientPreparednessForDurationLevel": "clientPreparednessForDurationLevel",
        "financialResponsibilityHandoverPreparedness": "financialResponsibilityHandoverPreparedness",
        "stressCopingEffectivness": "stressCopingEffectivness",
        "consideredImpactOnOtherRelationships": "consideredImpactOnOtherRelationships",
        "personalCareTaskComfortLevel": "personalCareTaskComfortLevel",
        "supportProviderPersonality": "supportProviderPersonality",
        "supportProviderStressCopingPreference": "supportProviderStressCopingPreference",
        "supportProviderRelationshipWithClient": "supportProviderRelationshipWithClient",
        "supportProviderConflictResolutionWithCareRecipientPreferences": "supportProviderConflictResolutionWithCareRecipientPreferences",
        "supportProviderToClientTrustLevel": "supportProviderToClientTrustLevel",
        "supportProviderCommunicationFrequency": "supportProviderCommunicationFrequency",
        "supportProviderEmotionalClosenessLevel": "supportProviderEmotionalClosenessLevel",
        "supportProviderRolePreference": "supportProviderRolePreference",
        "supportProviderFactorPrioritization": "supportProviderFactorPrioritization",
        "supportProviderValidCircumstancePreferences": "supportProviderValidCircumstancePreferences",
        "supportProviderCareWillingnessCapabilitiyComfortLevel": "supportProviderCareWillingnessCapabilitiyComfortLevel",
        "supportProviderFinancialStabilityLevel": "supportProviderFinancialStabilityLevel",
        "supportProviderExperienceLevel": "supportProviderExperienceLevel",
        "supportProviderSupportNetwork": "supportProviderSupportNetwork",
        "supportProviderRelationshipToCareRecipient": "supportProviderRelationshipToCareRecipient",
        "supportProviderHoursPerWeek": "supportProviderHoursPerWeek",
        "supportProviderRelationshipForecast": "supportProviderRelationshipForecast",
        "supportProviderEmotionalStrainForecast": "supportProviderEmotionalStrainForecast",
        "supportProviderFinancialWorryLevel": "supportProviderFinancialWorryLevel",
        "supportProviderCareInterferenceLevel": "supportProviderCareInterferenceLevel",
        "supportProviderPhysicalStressLevel": "supportProviderPhysicalStressLevel",
        "supportProviderEmotionalStressLevel": "supportProviderEmotionalStressLevel",
        "supportProviderDependentFamilyLevel": "supportProviderDependentFamilyLevel",
        "supportProviderChronicHealthIssueLevel": "supportProviderChronicHealthIssueLevel",
        "supportProviderMedicalFamiliarityLevel": "supportProviderMedicalFamiliarityLevel",
        "supportProviderTrainingComfortLevel": "supportProviderTrainingComfortLevel",
        "supportProviderSupportServiceComfortLevel": "supportProviderSupportServiceComfortLevel",
        "supportProviderEndOfLiveComfortLevel": "supportProviderEndOfLiveComfortLevel",
        "supportProviderDecisionMakingVoiceLevel": "supportProviderDecisionMakingVoiceLevel",
        "supportProviderSetbackComfortLevel": "supportProviderSetbackComfortLevel",
        "supportProviderDurationComfortLevel": "supportProviderDurationComfortLevel",
        "supportProviderFinancialResponsibilityComfortLevel": "supportProviderFinancialResponsibilityComfortLevel",
        "supportProviderAppreciationComfortLevel": "supportProviderAppreciationComfortLevel",
        "supportProviderOverwhelmPreferences": "supportProviderOverwhelmPreferences",
        "supportProviderImpactToOtherRelationshipsComfortLevel": "supportProviderImpactToOtherRelationshipsComfortLevel",
        "supportProviderPersonalCareTasksComfortLevel": "supportProviderPersonalCareTasksComfortLevel",
        "supportProviderHealthcareNavigationComfortLevel": "supportProviderHealthcareNavigationComfortLevel",
        "consentToTermsOfService": "consentToTermsOfService",
        "respondentRelationToClient": "respondentRelationToClient",
        "respondentRelationToClientSelfOrSpouse": "respondentRelationToClientSelfOrSpouse",
        "hasLongTermCareInsurance": "hasLongTermCareInsurance",
        "hasLongTermCareInsuranceProxy": "hasLongTermCareInsuranceProxy",
        "clientFirstName": "clientFirstName",
        "clientLastName": "clientLastName",
        "clientEmail": "clientEmail",
        "clientPhoneNumber": "clientPhoneNumber",
        "proxyFirstName": "proxyFirstName",
        "proxyLastName": "proxyLastName",
        "proxyEmail": "proxyEmail",
        "proxyPhoneNumber": "proxyPhoneNumber",
        "clientMarijuanaUsageType": "clientMarijuanaUsageType",
        "clientMedicalMarijuanaCondition": "clientMedicalMarijuanaCondition",
        "clientMushroomLastFiveYears": "clientMushroomLastFiveYears",
        "clientMedChangeLastTwelveMonths": "clientMedChangeLastTwelveMonths",
        "clientMedChangeDescLastTwelveMonths": "clientMedChangeDescLastTwelveMonths",
        "clientMedChangeCauseLastTwelveMonths": "clientMedChangeCauseLastTwelveMonths",
        "clientPhysicalTherapyTense": "clientPhysicalTherapyTense",
        "clientPhysicalTherapyFrequency": "clientPhysicalTherapyFrequency",
        "clientPhysicalTherapyEnd": "clientPhysicalTherapyEnd",
        "clientPhysicalTherapyReason": "clientPhysicalTherapyReason",
        "clientOccupationalTherapyTense": "clientOccupationalTherapyTense",
        "clientOccupationalTherapyFrequency": "clientOccupationalTherapyFrequency",
        "clientOccupationalTherapyEnd": "clientOccupationalTherapyEnd",
        "clientOccupationalTherapyReason": "clientOccupationalTherapyReason",
        "clientChiropracticTherapyTense": "clientChiropracticTherapyTense",
        "clientChiropracticTherapyFrequency": "clientChiropracticTherapyFrequency",
        "clientChiropracticTherapyEnd": "clientChiropracticTherapyEnd",
        "clientChiropracticTherapyReason": "clientChiropracticTherapyReason",
        "clientPriorTwoYearERCount": "clientPriorTwoYearERCount",
        "clientERReason": "clientERReason",
        "clientAgeReceivedHelpClimbingStairs": "clientAgeReceivedHelpClimbingStairs",
        "clientAgeReceivedHelpShopping": "clientAgeReceivedHelpShopping",
        "clientAgeReceivedHelpTakingMedication": "clientAgeReceivedHelpTakingMedication",
        "clientAgeReceivedHelpPreparingMeals": "clientAgeReceivedHelpPreparingMeals",
        "clientAgeReceivedHelpManagingFinances": "clientAgeReceivedHelpManagingFinances",
        "clientAgeReceivedHelpMakingPhoneCalls": "clientAgeReceivedHelpMakingPhoneCalls",
        "clientHighBloodPressureYear": "clientHighBloodPressureYear",
        "clientHighBloodPressureControlled": "clientHighBloodPressureControlled",
        "clientHeartConditionDiagnosisYear": "clientHeartConditionDiagnosisYear",
        "clientHeartConditionDiagnosisTreatment": "clientHeartConditionDiagnosisTreatment",
        "clientDiabetesDiagnosisYear": "clientDiabetesDiagnosisYear",
        "clientDiabetesControlMethod": "clientDiabetesControlMethod",
        "clientMetabolicDisorderYear": "clientMetabolicDisorderYear",
        "clientMetabolicDisorderControlled": "clientMetabolicDisorderControlled",
        "clientLungRespiratoryYear": "clientLungRespiratoryYear",
        "clientLungRespiratoryTreatment": "clientLungRespiratoryTreatment",
        "clientDigestiveYear": "clientDigestiveYear",
        "clientBrainInjuryLastEpisodeYear": "clientBrainInjuryLastEpisodeYear",
        "clientBrainInjuryLimitations": "clientBrainInjuryLimitations",
        "clientCognitiveMemoryYear": "clientCognitiveMemoryYear",
        "clientCognitiveMemorySeverity": "clientCognitiveMemorySeverity",
        "clientPsychiatricYear": "clientPsychiatricYear",
        "clientCancerYear": "clientCancerYear",
        "clientCancerStage": "clientCancerStage",
        "clientCancerTreatment": "clientCancerTreatment",
        "clientCancerTreatmentDate": "clientCancerTreatmentDate",
        "clientCancerRecurrenceSpread": "clientCancerRecurrenceSpread",
        "clientEENTDYear": "clientEENTDYear",
        "clientEENTDSurgery": "clientEENTDSurgery",
        "clientEENTDSurgeryType": "clientEENTDSurgeryType",
        "clientEENTDLimits": "clientEENTDLimits",
        "clientGenitourinaryYear": "clientGenitourinaryYear",
        "clientImmuneSystemYear": "clientImmuneSystemYear",
        "clientInjuriesKnee": "clientInjuriesKnee",
        "clientInjuriesKneeYear": "clientInjuriesKneeYear",
        "clientInjuriesKneeSurgeryYear": "clientInjuriesKneeSurgeryYear",
        "clientInjuriesKneeSurgeryPlanned": "clientInjuriesKneeSurgeryPlanned",
        "clientInjuriesAnkle": "clientInjuriesAnkle",
        "clientInjuriesAnkleYear": "clientInjuriesAnkleYear",
        "clientInjuriesAnkleSurgeryYear": "clientInjuriesAnkleSurgeryYear",
        "clientInjuriesAnkleSurgeryPlanned": "clientInjuriesAnkleSurgeryPlanned",
        "clientInjuriesHip": "clientInjuriesHip",
        "clientInjuriesHipYear": "clientInjuriesHipYear",
        "clientInjuriesHipSurgeryYear": "clientInjuriesHipSurgeryYear",
        "clientInjuriesHipSurgeryPlanned": "clientInjuriesHipSurgeryPlanned",
        "clientInjuriesBack": "clientInjuriesBack",
        "clientInjuriesBackYear": "clientInjuriesBackYear",
        "clientInjuriesBackSurgeryYear": "clientInjuriesBackSurgeryYear",
        "clientInjuriesBackSurgeryPlanned": "clientInjuriesBackSurgeryPlanned",
        "clientInjuriesShoulder": "clientInjuriesShoulder",
        "clientInjuriesShoulderYear": "clientInjuriesShoulderYear",
        "clientInjuriesShoulderSurgeryYear": "clientInjuriesShoulderSurgeryYear",
        "clientInjuriesShoulderSurgeryPlanned": "clientInjuriesShoulderSurgeryPlanned",
        "clientInjuriesNeck": "clientInjuriesNeck",
        "clientInjuriesNeckYear": "clientInjuriesNeckYear",
        "clientInjuriesNeckSurgeryYear": "clientInjuriesNeckSurgeryYear",
        "clientInjuriesNeckSurgeryPlanned": "clientInjuriesNeckSurgeryPlanned",
        "clientInjuriesWrist": "clientInjuriesWrist",
        "clientInjuriesWristYear": "clientInjuriesWristYear",
        "clientInjuriesWristSurgeryYear": "clientInjuriesWristSurgeryYear",
        "clientInjuriesWristSurgeryPlanned": "clientInjuriesWristSurgeryPlanned",
        "clientInjuriesElbow": "clientInjuriesElbow",
        "clientInjuriesElbowYear": "clientInjuriesElbowYear",
        "clientInjuriesElbowSurgeryYear": "clientInjuriesElbowSurgeryYear",
        "clientInjuriesElbowSurgeryPlanned": "clientInjuriesElbowSurgeryPlanned",
        "clientInjuriesFoot": "clientInjuriesFoot",
        "clientInjuriesFootYear": "clientInjuriesFootYear",
        "clientInjuriesFootSurgeryYear": "clientInjuriesFootSurgeryYear",
        "clientInjuriesFootSurgeryPlanned": "clientInjuriesFootSurgeryPlanned",
        "clientInjuryJoints": "clientInjuryJoints",
        "clientInjuryJointsYear": "clientInjuryJointsYear",
        "clientInjuryJointsSurgeryYear": "clientInjuryJointsSurgeryYear",
        "clientInjuryJointsSurgeryPlanned": "clientInjuryJointsSurgeryPlanned",
        "clientInjuryJointInjectionLastTwelveMonths": "clientInjuryJointInjectionLastTwelveMonths",
        "clientInjuryAdditionalDetails": "clientInjuryAdditionalDetails",
        "clientUndiagnosedCondition": "clientUndiagnosedCondition",
        "clientLastDoctorVisitYear": "clientLastDoctorVisitYear",
        "clientAdditionalMedicalHistory": "clientAdditionalMedicalHistory",
        "clientLtcZipCode": "clientLtcZipCode",
        "clientOtherHealthPlanList": "clientOtherHealthPlanList",
        "clientProfessionalSupportNetworkList": "clientProfessionalSupportNetworkList"
      },
      "labelsByValue": {
        "clientMaritalStatus": "clientMaritalStatus",
        "partnerFirstName": "partnerFirstName",
        "partnerLastName": "partnerLastName",
        "householdPartnered": "householdPartnered",
        "householdHouseholdSize": "householdHouseholdSize",
        "clientBirthDate": "clientBirthDate",
        "clientGenderIdentity": "clientGenderIdentity",
        "clientGenderAtBirth": "clientGenderAtBirth",
        "clientRace": "clientRace",
        "clientZipCode": "clientZipCode",
        "clientCensusRegion": "clientCensusRegion",
        "clientHighestDegree": "clientHighestDegree",
        "clientLivingSiblingsCount": "clientLivingSiblingsCount",
        "householdLivingChildrenCount": "householdLivingChildrenCount",
        "householdPriorYearIncome": "householdPriorYearIncome",
        "householdTotalAssetsValue": "householdTotalAssetsValue",
        "financialAssetTypes": "financialAssetTypes",
        "legalDocuments": "legalDocuments",
        "clientHealthPlanList": "clientHealthPlanList",
        "clientIndependencePreference": "clientIndependencePreference",
        "clientFinancialSecurityPreference": "clientFinancialSecurityPreference",
        "clientFamilyInvolvementPreference": "clientFamilyInvolvementPreference",
        "clientMentalHealthIssuesList": "clientMentalHealthIssuesList",
        "clientSmokerEver": "clientSmokerEver",
        "clientSmokedRecently": "clientSmokedRecently",
        "clientUsesRegularPrescriptionDrugs": "clientUsesRegularPrescriptionDrugs",
        "clientWeightPounds": "clientWeightPounds",
        "clientHeightInches": "clientHeightInches",
        "clientPriorTwoYearHospitalizationCount": "clientPriorTwoYearHospitalizationCount",
        "clientActivitiesWithDifficultyList": "clientActivitiesWithDifficultyList",
        "clientActivitiesReceivedAssistanceList": "clientActivitiesReceivedAssistanceList",
        "clientAgeReceivedHelpBathing": "clientAgeReceivedHelpBathing",
        "clientAgeReceivedHelpEating": "clientAgeReceivedHelpEating",
        "clientAgeReceivedHelpDressing": "clientAgeReceivedHelpDressing",
        "clientAgeReceivedHelpWalking": "clientAgeReceivedHelpWalking",
        "clientAgeReceivedHelpAccessingBed": "clientAgeReceivedHelpAccessingBed",
        "clientAgeReceivedHelpToileting": "clientAgeReceivedHelpToileting",
        "clientDiagnosesList": "clientDiagnosesList",
        "clientInjuriesList": "clientInjuriesList",
        "clientCanAnswerForFather": "clientCanAnswerForFather",
        "clientFatherIsAlive": "clientFatherIsAlive",
        "clientFatherAgeAtSurveyDate": "clientFatherAgeAtSurveyDate",
        "clientFatherAgeOfDeathAtSurveyDate": "clientFatherAgeOfDeathAtSurveyDate",
        "clientFatherRequiredAssistance": "clientFatherRequiredAssistance",
        "clientFatherAssistanceDurationMonthCount": "clientFatherAssistanceDurationMonthCount",
        "clientFatherNursingHomeEver": "clientFatherNursingHomeEver",
        "clientFatherNursingHomeMonthCount": "clientFatherNursingHomeMonthCount",
        "clientFatherCardiovascularEver": "clientFatherCardiovascularEver",
        "clientFatherMemoryProblemsEver": "clientFatherMemoryProblemsEver",
        "clientFatherMemoryDiagnosesList": "clientFatherMemoryDiagnosesList",
        "clientCanAnswerForMother": "clientCanAnswerForMother",
        "clientMotherIsAlive": "clientMotherIsAlive",
        "clientMotherAgeAtSurveyDate": "clientMotherAgeAtSurveyDate",
        "clientMotherAgeOfDeathAtSurveyDate": "clientMotherAgeOfDeathAtSurveyDate",
        "clientMotherRequiredAssistance": "clientMotherRequiredAssistance",
        "clientMotherAssistanceDurationMonthCount": "clientMotherAssistanceDurationMonthCount",
        "clientMotherNursingHomeEver": "clientMotherNursingHomeEver",
        "clientMotherNursingHomeMonthCount": "clientMotherNursingHomeMonthCount",
        "clientMotherCardiovascularEver": "clientMotherCardiovascularEver",
        "clientMotherMemoryProblemsEver": "clientMotherMemoryProblemsEver",
        "clientMotherMemoryDiagnosesList": "clientMotherMemoryDiagnosesList",
        "clientHospitalizedERLastTwelveMonths": "clientHospitalizedERLastTwelveMonths",
        "clientMedicationIntake": "clientMedicationIntake",
        "clientTherapyTypes": "clientTherapyTypes",
        "clientMarijuanaLastFiveYears": "clientMarijuanaLastFiveYears",
        "clientHardDrugsLastFiveYears": "clientHardDrugsLastFiveYears",
        "clientAssistiveDevicesList": "clientAssistiveDevicesList",
        "clientSubstancesUsed": "clientSubstancesUsed",
        "clientWeightGainedLost": "clientWeightGainedLost",
        "clientWeightGainedLastTwelveMonths": "clientWeightGainedLastTwelveMonths",
        "clientWeightLostLastTwelveMonths": "clientWeightLostLastTwelveMonths",
        "clientHospitalizationReason": "clientHospitalizationReason",
        "clientBloodPressureReading": "clientBloodPressureReading",
        "clientHeartConditionDiagnosis": "clientHeartConditionDiagnosis",
        "clientDiabetesTypeDiagnosisList": "clientDiabetesTypeDiagnosisList",
        "clientLastA1CReading": "clientLastA1CReading",
        "clientMetabolicDisordersList": "clientMetabolicDisordersList",
        "clientLungRespiratoryDiagnosis": "clientLungRespiratoryDiagnosis",
        "clientDigestiveDiagnosis": "clientDigestiveDiagnosis",
        "clientBrainInjuryDiagnosis": "clientBrainInjuryDiagnosis",
        "clientCognitiveMemoryDiagnosis": "clientCognitiveMemoryDiagnosis",
        "clientPsychiatricDiagnosis": "clientPsychiatricDiagnosis",
        "clientCancerTypeLocation": "clientCancerTypeLocation",
        "clientEENTDiagnosis": "clientEENTDiagnosis",
        "clientGenitourinaryDiagnosis": "clientGenitourinaryDiagnosis",
        "clientImmuneSystemDiagnosis": "clientImmuneSystemDiagnosis",
        "clientDisabilityWorkersComp": "clientDisabilityWorkersComp",
        "clientCigaretteLastFiveYears": "clientCigaretteLastFiveYears",
        "clientCigarPipeLastFiveYears": "clientCigarPipeLastFiveYears",
        "clientVapeLastFiveYears": "clientVapeLastFiveYears",
        "clientChewTobaccoLastFiveYears": "clientChewTobaccoLastFiveYears",
        "clientAlcoholLastFiveYears": "clientAlcoholLastFiveYears",
        "clientMedicaidProgramName": "clientMedicaidProgramName",
        "clientInjuryArthritis": "clientInjuryArthritis",
        "financialSecurityPreference": "financialSecurityPreference",
        "independenceandQualityofLifePreference": "independenceandQualityofLifePreference",
        "careEnvironmentPreference": "careEnvironmentPreference",
        "familyInvolvementPreference": "familyInvolvementPreference",
        "riskAssessmentPreference": "riskAssessmentPreference",
        "flexibilityPreference": "flexibilityPreference",
        "costEffectivenessPreference": "costEffectivenessPreference",
        "clientOwnPersonalityPerceptions": "clientOwnPersonalityPerceptions",
        "stressManagementPreference": "stressManagementPreference",
        "disagreementResolutionPreference": "disagreementResolutionPreference",
        "supportProviderInvolvement": "supportProviderInvolvement",
        "rankedFactors": "rankedFactors",
        "incentiveToAcceptCare": "incentiveToAcceptCare",
        "willingnessToAcceptCare": "willingnessToAcceptCare",
        "trustLevel": "trustLevel",
        "currentCommunnicationFrequency": "currentCommunnicationFrequency",
        "emotionalCloseness": "emotionalCloseness",
        "rolePreference": "rolePreference",
        "willingnessToReceiveCare": "willingnessToReceiveCare",
        "clientFinancialStability": "clientFinancialStability",
        "previousExperience": "previousExperience",
        "potentialSupportProvider": "potentialSupportProvider",
        "relationshipCloseness": "relationshipCloseness",
        "relationshipChangeComfortLevel": "relationshipChangeComfortLevel",
        "financialNeedConcernLevel": "financialNeedConcernLevel",
        "receivingCareInterferenceLikelihood": "receivingCareInterferenceLikelihood",
        "physicalStressLevel": "physicalStressLevel",
        "emotionalStressLevel": "emotionalStressLevel",
        "preferredSupportServices": "preferredSupportServices",
        "endOfLifeComfortLevel": "endOfLifeComfortLevel",
        "clientDecisionMakingInvolvement": "clientDecisionMakingInvolvement",
        "setbackImpactLevel": "setbackImpactLevel",
        "clientPreparednessForDurationLevel": "clientPreparednessForDurationLevel",
        "financialResponsibilityHandoverPreparedness": "financialResponsibilityHandoverPreparedness",
        "stressCopingEffectivness": "stressCopingEffectivness",
        "consideredImpactOnOtherRelationships": "consideredImpactOnOtherRelationships",
        "personalCareTaskComfortLevel": "personalCareTaskComfortLevel",
        "supportProviderPersonality": "supportProviderPersonality",
        "supportProviderStressCopingPreference": "supportProviderStressCopingPreference",
        "supportProviderRelationshipWithClient": "supportProviderRelationshipWithClient",
        "supportProviderConflictResolutionWithCareRecipientPreferences": "supportProviderConflictResolutionWithCareRecipientPreferences",
        "supportProviderToClientTrustLevel": "supportProviderToClientTrustLevel",
        "supportProviderCommunicationFrequency": "supportProviderCommunicationFrequency",
        "supportProviderEmotionalClosenessLevel": "supportProviderEmotionalClosenessLevel",
        "supportProviderRolePreference": "supportProviderRolePreference",
        "supportProviderFactorPrioritization": "supportProviderFactorPrioritization",
        "supportProviderValidCircumstancePreferences": "supportProviderValidCircumstancePreferences",
        "supportProviderCareWillingnessCapabilitiyComfortLevel": "supportProviderCareWillingnessCapabilitiyComfortLevel",
        "supportProviderFinancialStabilityLevel": "supportProviderFinancialStabilityLevel",
        "supportProviderExperienceLevel": "supportProviderExperienceLevel",
        "supportProviderSupportNetwork": "supportProviderSupportNetwork",
        "supportProviderRelationshipToCareRecipient": "supportProviderRelationshipToCareRecipient",
        "supportProviderHoursPerWeek": "supportProviderHoursPerWeek",
        "supportProviderRelationshipForecast": "supportProviderRelationshipForecast",
        "supportProviderEmotionalStrainForecast": "supportProviderEmotionalStrainForecast",
        "supportProviderFinancialWorryLevel": "supportProviderFinancialWorryLevel",
        "supportProviderCareInterferenceLevel": "supportProviderCareInterferenceLevel",
        "supportProviderPhysicalStressLevel": "supportProviderPhysicalStressLevel",
        "supportProviderEmotionalStressLevel": "supportProviderEmotionalStressLevel",
        "supportProviderDependentFamilyLevel": "supportProviderDependentFamilyLevel",
        "supportProviderChronicHealthIssueLevel": "supportProviderChronicHealthIssueLevel",
        "supportProviderMedicalFamiliarityLevel": "supportProviderMedicalFamiliarityLevel",
        "supportProviderTrainingComfortLevel": "supportProviderTrainingComfortLevel",
        "supportProviderSupportServiceComfortLevel": "supportProviderSupportServiceComfortLevel",
        "supportProviderEndOfLiveComfortLevel": "supportProviderEndOfLiveComfortLevel",
        "supportProviderDecisionMakingVoiceLevel": "supportProviderDecisionMakingVoiceLevel",
        "supportProviderSetbackComfortLevel": "supportProviderSetbackComfortLevel",
        "supportProviderDurationComfortLevel": "supportProviderDurationComfortLevel",
        "supportProviderFinancialResponsibilityComfortLevel": "supportProviderFinancialResponsibilityComfortLevel",
        "supportProviderAppreciationComfortLevel": "supportProviderAppreciationComfortLevel",
        "supportProviderOverwhelmPreferences": "supportProviderOverwhelmPreferences",
        "supportProviderImpactToOtherRelationshipsComfortLevel": "supportProviderImpactToOtherRelationshipsComfortLevel",
        "supportProviderPersonalCareTasksComfortLevel": "supportProviderPersonalCareTasksComfortLevel",
        "supportProviderHealthcareNavigationComfortLevel": "supportProviderHealthcareNavigationComfortLevel",
        "consentToTermsOfService": "consentToTermsOfService",
        "respondentRelationToClient": "respondentRelationToClient",
        "respondentRelationToClientSelfOrSpouse": "respondentRelationToClientSelfOrSpouse",
        "hasLongTermCareInsurance": "hasLongTermCareInsurance",
        "hasLongTermCareInsuranceProxy": "hasLongTermCareInsuranceProxy",
        "clientFirstName": "clientFirstName",
        "clientLastName": "clientLastName",
        "clientEmail": "clientEmail",
        "clientPhoneNumber": "clientPhoneNumber",
        "proxyFirstName": "proxyFirstName",
        "proxyLastName": "proxyLastName",
        "proxyEmail": "proxyEmail",
        "proxyPhoneNumber": "proxyPhoneNumber",
        "clientMarijuanaUsageType": "clientMarijuanaUsageType",
        "clientMedicalMarijuanaCondition": "clientMedicalMarijuanaCondition",
        "clientMushroomLastFiveYears": "clientMushroomLastFiveYears",
        "clientMedChangeLastTwelveMonths": "clientMedChangeLastTwelveMonths",
        "clientMedChangeDescLastTwelveMonths": "clientMedChangeDescLastTwelveMonths",
        "clientMedChangeCauseLastTwelveMonths": "clientMedChangeCauseLastTwelveMonths",
        "clientPhysicalTherapyTense": "clientPhysicalTherapyTense",
        "clientPhysicalTherapyFrequency": "clientPhysicalTherapyFrequency",
        "clientPhysicalTherapyEnd": "clientPhysicalTherapyEnd",
        "clientPhysicalTherapyReason": "clientPhysicalTherapyReason",
        "clientOccupationalTherapyTense": "clientOccupationalTherapyTense",
        "clientOccupationalTherapyFrequency": "clientOccupationalTherapyFrequency",
        "clientOccupationalTherapyEnd": "clientOccupationalTherapyEnd",
        "clientOccupationalTherapyReason": "clientOccupationalTherapyReason",
        "clientChiropracticTherapyTense": "clientChiropracticTherapyTense",
        "clientChiropracticTherapyFrequency": "clientChiropracticTherapyFrequency",
        "clientChiropracticTherapyEnd": "clientChiropracticTherapyEnd",
        "clientChiropracticTherapyReason": "clientChiropracticTherapyReason",
        "clientPriorTwoYearERCount": "clientPriorTwoYearERCount",
        "clientERReason": "clientERReason",
        "clientAgeReceivedHelpClimbingStairs": "clientAgeReceivedHelpClimbingStairs",
        "clientAgeReceivedHelpShopping": "clientAgeReceivedHelpShopping",
        "clientAgeReceivedHelpTakingMedication": "clientAgeReceivedHelpTakingMedication",
        "clientAgeReceivedHelpPreparingMeals": "clientAgeReceivedHelpPreparingMeals",
        "clientAgeReceivedHelpManagingFinances": "clientAgeReceivedHelpManagingFinances",
        "clientAgeReceivedHelpMakingPhoneCalls": "clientAgeReceivedHelpMakingPhoneCalls",
        "clientHighBloodPressureYear": "clientHighBloodPressureYear",
        "clientHighBloodPressureControlled": "clientHighBloodPressureControlled",
        "clientHeartConditionDiagnosisYear": "clientHeartConditionDiagnosisYear",
        "clientHeartConditionDiagnosisTreatment": "clientHeartConditionDiagnosisTreatment",
        "clientDiabetesDiagnosisYear": "clientDiabetesDiagnosisYear",
        "clientDiabetesControlMethod": "clientDiabetesControlMethod",
        "clientMetabolicDisorderYear": "clientMetabolicDisorderYear",
        "clientMetabolicDisorderControlled": "clientMetabolicDisorderControlled",
        "clientLungRespiratoryYear": "clientLungRespiratoryYear",
        "clientLungRespiratoryTreatment": "clientLungRespiratoryTreatment",
        "clientDigestiveYear": "clientDigestiveYear",
        "clientBrainInjuryLastEpisodeYear": "clientBrainInjuryLastEpisodeYear",
        "clientBrainInjuryLimitations": "clientBrainInjuryLimitations",
        "clientCognitiveMemoryYear": "clientCognitiveMemoryYear",
        "clientCognitiveMemorySeverity": "clientCognitiveMemorySeverity",
        "clientPsychiatricYear": "clientPsychiatricYear",
        "clientCancerYear": "clientCancerYear",
        "clientCancerStage": "clientCancerStage",
        "clientCancerTreatment": "clientCancerTreatment",
        "clientCancerTreatmentDate": "clientCancerTreatmentDate",
        "clientCancerRecurrenceSpread": "clientCancerRecurrenceSpread",
        "clientEENTDYear": "clientEENTDYear",
        "clientEENTDSurgery": "clientEENTDSurgery",
        "clientEENTDSurgeryType": "clientEENTDSurgeryType",
        "clientEENTDLimits": "clientEENTDLimits",
        "clientGenitourinaryYear": "clientGenitourinaryYear",
        "clientImmuneSystemYear": "clientImmuneSystemYear",
        "clientInjuriesKnee": "clientInjuriesKnee",
        "clientInjuriesKneeYear": "clientInjuriesKneeYear",
        "clientInjuriesKneeSurgeryYear": "clientInjuriesKneeSurgeryYear",
        "clientInjuriesKneeSurgeryPlanned": "clientInjuriesKneeSurgeryPlanned",
        "clientInjuriesAnkle": "clientInjuriesAnkle",
        "clientInjuriesAnkleYear": "clientInjuriesAnkleYear",
        "clientInjuriesAnkleSurgeryYear": "clientInjuriesAnkleSurgeryYear",
        "clientInjuriesAnkleSurgeryPlanned": "clientInjuriesAnkleSurgeryPlanned",
        "clientInjuriesHip": "clientInjuriesHip",
        "clientInjuriesHipYear": "clientInjuriesHipYear",
        "clientInjuriesHipSurgeryYear": "clientInjuriesHipSurgeryYear",
        "clientInjuriesHipSurgeryPlanned": "clientInjuriesHipSurgeryPlanned",
        "clientInjuriesBack": "clientInjuriesBack",
        "clientInjuriesBackYear": "clientInjuriesBackYear",
        "clientInjuriesBackSurgeryYear": "clientInjuriesBackSurgeryYear",
        "clientInjuriesBackSurgeryPlanned": "clientInjuriesBackSurgeryPlanned",
        "clientInjuriesShoulder": "clientInjuriesShoulder",
        "clientInjuriesShoulderYear": "clientInjuriesShoulderYear",
        "clientInjuriesShoulderSurgeryYear": "clientInjuriesShoulderSurgeryYear",
        "clientInjuriesShoulderSurgeryPlanned": "clientInjuriesShoulderSurgeryPlanned",
        "clientInjuriesNeck": "clientInjuriesNeck",
        "clientInjuriesNeckYear": "clientInjuriesNeckYear",
        "clientInjuriesNeckSurgeryYear": "clientInjuriesNeckSurgeryYear",
        "clientInjuriesNeckSurgeryPlanned": "clientInjuriesNeckSurgeryPlanned",
        "clientInjuriesWrist": "clientInjuriesWrist",
        "clientInjuriesWristYear": "clientInjuriesWristYear",
        "clientInjuriesWristSurgeryYear": "clientInjuriesWristSurgeryYear",
        "clientInjuriesWristSurgeryPlanned": "clientInjuriesWristSurgeryPlanned",
        "clientInjuriesElbow": "clientInjuriesElbow",
        "clientInjuriesElbowYear": "clientInjuriesElbowYear",
        "clientInjuriesElbowSurgeryYear": "clientInjuriesElbowSurgeryYear",
        "clientInjuriesElbowSurgeryPlanned": "clientInjuriesElbowSurgeryPlanned",
        "clientInjuriesFoot": "clientInjuriesFoot",
        "clientInjuriesFootYear": "clientInjuriesFootYear",
        "clientInjuriesFootSurgeryYear": "clientInjuriesFootSurgeryYear",
        "clientInjuriesFootSurgeryPlanned": "clientInjuriesFootSurgeryPlanned",
        "clientInjuryJoints": "clientInjuryJoints",
        "clientInjuryJointsYear": "clientInjuryJointsYear",
        "clientInjuryJointsSurgeryYear": "clientInjuryJointsSurgeryYear",
        "clientInjuryJointsSurgeryPlanned": "clientInjuryJointsSurgeryPlanned",
        "clientInjuryJointInjectionLastTwelveMonths": "clientInjuryJointInjectionLastTwelveMonths",
        "clientInjuryAdditionalDetails": "clientInjuryAdditionalDetails",
        "clientUndiagnosedCondition": "clientUndiagnosedCondition",
        "clientLastDoctorVisitYear": "clientLastDoctorVisitYear",
        "clientAdditionalMedicalHistory": "clientAdditionalMedicalHistory",
        "clientLtcZipCode": "clientLtcZipCode",
        "clientOtherHealthPlanList": "clientOtherHealthPlanList",
        "clientProfessionalSupportNetworkList": "clientProfessionalSupportNetworkList"
      }
    },
    "surveys": {
      "tableName": "Surveys",
      "objectType": "table",
      "fields": {
        "surveyVersionId": {
          "fieldName": "surveyVersionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys"
        },
        "surveyVersionDateTime": {
          "fieldName": "surveyVersionDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys"
        },
        "surveyId": {
          "fieldName": "surveyId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys"
        },
        "surveyDefinitionId": {
          "fieldName": "surveyDefinitionId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys",
          "referenceTableName": "SurveyDefinitions",
          "referenceFieldName": "surveyDefinitionId"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "supportProviderId": {
          "fieldName": "supportProviderId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Surveys",
          "referenceTableName": "SupportProviders",
          "referenceFieldName": "supportProviderId"
        },
        "surveyStatus": {
          "fieldName": "surveyStatus",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Surveys",
          "referenceTableName": "SurveyStatuses",
          "referenceFieldName": "surveyStatusId"
        },
        "lastPageSeen": {
          "fieldName": "lastPageSeen",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Surveys"
        },
        "surveySubmittedDateTime": {
          "fieldName": "surveySubmittedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Surveys"
        }
      },
      "orderedFieldNames": [
        "surveyVersionId",
        "surveyVersionDateTime",
        "surveyId",
        "surveyDefinitionId",
        "clientId",
        "supportProviderId",
        "surveyStatus",
        "lastPageSeen",
        "surveySubmittedDateTime"
      ],
      "primaryKey": "surveyVersionId"
    },
    "surveyAnswers": {
      "tableName": "SurveyAnswers",
      "objectType": "table",
      "fields": {
        "surveyAnswerId": {
          "fieldName": "surveyAnswerId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyAnswers"
        },
        "surveyVersionId": {
          "fieldName": "surveyVersionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "SurveyAnswers",
          "referenceTableName": "Surveys",
          "referenceFieldName": "surveyVersionId"
        },
        "surveyQuestionRef": {
          "fieldName": "surveyQuestionRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyAnswers",
          "referenceTableName": "SurveyQuestions",
          "referenceFieldName": "surveyQuestionRef"
        },
        "surveyAnswerValue": {
          "fieldName": "surveyAnswerValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "SurveyAnswers"
        }
      },
      "orderedFieldNames": [
        "surveyAnswerId",
        "surveyVersionId",
        "surveyQuestionRef",
        "surveyAnswerValue"
      ],
      "primaryKey": "surveyAnswerId"
    },
    "inferenceSets": {
      "tableName": "InferenceSets",
      "objectType": "table",
      "fields": {
        "inferenceSetVersionId": {
          "fieldName": "inferenceSetVersionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "inferenceSetId": {
          "fieldName": "inferenceSetId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "inferenceSetVersionDateTime": {
          "fieldName": "inferenceSetVersionDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InferenceSets",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "inferenceSetRunDateTime": {
          "fieldName": "inferenceSetRunDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcLikelihoodEver": {
          "fieldName": "ltcLikelihoodEver",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcLikelihood10Years": {
          "fieldName": "ltcLikelihood10Years",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcAtAge": {
          "fieldName": "ltcAtAge",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcDurationYears": {
          "fieldName": "ltcDurationYears",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "partnerHelperPercent": {
          "fieldName": "partnerHelperPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "professionalHelperPercent": {
          "fieldName": "professionalHelperPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "childHelperPercent": {
          "fieldName": "childHelperPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "otherFamilyHelperPercent": {
          "fieldName": "otherFamilyHelperPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "monthlyHelpHours": {
          "fieldName": "monthlyHelpHours",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcTotalCost": {
          "fieldName": "ltcTotalCost",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcFamilyCareCost": {
          "fieldName": "ltcFamilyCareCost",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "ltcProfessionalShareCost": {
          "fieldName": "ltcProfessionalShareCost",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "totalCareHoursProvided": {
          "fieldName": "totalCareHoursProvided",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "careProvidedPercent": {
          "fieldName": "careProvidedPercent",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "totalCareHoursNeeded": {
          "fieldName": "totalCareHoursNeeded",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "childrenCareHoursProvided": {
          "fieldName": "childrenCareHoursProvided",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "otherFamilyCareHoursProvided": {
          "fieldName": "otherFamilyCareHoursProvided",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "partnerCareHoursProvided": {
          "fieldName": "partnerCareHoursProvided",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "professionalCareHoursProvided": {
          "fieldName": "professionalCareHoursProvided",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseOneCareHoursRatio": {
          "fieldName": "phaseOneCareHoursRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseTwoCareHoursRatio": {
          "fieldName": "phaseTwoCareHoursRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseThreeCareHoursRatio": {
          "fieldName": "phaseThreeCareHoursRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseOneDurationYearsRatio": {
          "fieldName": "phaseOneDurationYearsRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseTwoDurationYearsRatio": {
          "fieldName": "phaseTwoDurationYearsRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        },
        "phaseThreeDurationYearsRatio": {
          "fieldName": "phaseThreeDurationYearsRatio",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InferenceSets"
        }
      },
      "orderedFieldNames": [
        "inferenceSetVersionId",
        "inferenceSetId",
        "inferenceSetVersionDateTime",
        "clientId",
        "inferenceSetRunDateTime",
        "ltcLikelihoodEver",
        "ltcLikelihood10Years",
        "ltcAtAge",
        "ltcDurationYears",
        "partnerHelperPercent",
        "professionalHelperPercent",
        "childHelperPercent",
        "otherFamilyHelperPercent",
        "monthlyHelpHours",
        "ltcTotalCost",
        "ltcFamilyCareCost",
        "ltcProfessionalShareCost",
        "totalCareHoursProvided",
        "careProvidedPercent",
        "totalCareHoursNeeded",
        "childrenCareHoursProvided",
        "otherFamilyCareHoursProvided",
        "partnerCareHoursProvided",
        "professionalCareHoursProvided",
        "phaseOneCareHoursRatio",
        "phaseTwoCareHoursRatio",
        "phaseThreeCareHoursRatio",
        "phaseOneDurationYearsRatio",
        "phaseTwoDurationYearsRatio",
        "phaseThreeDurationYearsRatio"
      ],
      "primaryKey": "inferenceSetVersionId"
    },
    "fundingSources": {
      "tableName": "FundingSources",
      "objectType": "table",
      "fields": {
        "fundingSourceId": {
          "fieldName": "fundingSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSources"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSources",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "fundingSourceLabel": {
          "fieldName": "fundingSourceLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSources"
        }
      },
      "orderedFieldNames": [
        "fundingSourceId",
        "clientId",
        "fundingSourceLabel"
      ],
      "primaryKey": "fundingSourceId"
    },
    "fundingSourceDetails": {
      "tableName": "FundingSourceDetails",
      "objectType": "table",
      "fields": {
        "fundingSourceDetailId": {
          "fieldName": "fundingSourceDetailId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSourceDetails"
        },
        "fundingSourceId": {
          "fieldName": "fundingSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSourceDetails",
          "referenceTableName": "FundingSources",
          "referenceFieldName": "fundingSourceId"
        },
        "fundingSourceDetailLabel": {
          "fieldName": "fundingSourceDetailLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSourceDetails"
        },
        "fundingSourceDetailValue": {
          "fieldName": "fundingSourceDetailValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FundingSourceDetails"
        }
      },
      "orderedFieldNames": [
        "fundingSourceDetailId",
        "fundingSourceId",
        "fundingSourceDetailLabel",
        "fundingSourceDetailValue"
      ],
      "primaryKey": "fundingSourceDetailId"
    },
    "magicLinks": {
      "tableName": "MagicLinks",
      "objectType": "table",
      "fields": {
        "magicLinkId": {
          "fieldName": "magicLinkId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "MagicLinks"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "MagicLinks",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "token": {
          "fieldName": "token",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "MagicLinks"
        },
        "usedDateTime": {
          "fieldName": "usedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "MagicLinks"
        },
        "expirationDateTime": {
          "fieldName": "expirationDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinks"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinks"
        }
      },
      "orderedFieldNames": [
        "magicLinkId",
        "clientId",
        "token",
        "usedDateTime",
        "expirationDateTime",
        "createdDateTime"
      ],
      "primaryKey": "magicLinkId"
    },
    "magicLinkVerificationCodes": {
      "tableName": "MagicLinkVerificationCodes",
      "objectType": "table",
      "fields": {
        "magicLinkVerificationId": {
          "fieldName": "magicLinkVerificationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "magicLinkToken": {
          "fieldName": "magicLinkToken",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "verificationCode": {
          "fieldName": "verificationCode",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "attemptCount": {
          "fieldName": "attemptCount",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "maxAttempts": {
          "fieldName": "maxAttempts",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "isVerified": {
          "fieldName": "isVerified",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "expiresAt": {
          "fieldName": "expiresAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "MagicLinkVerificationCodes"
        }
      },
      "orderedFieldNames": [
        "magicLinkVerificationId",
        "magicLinkToken",
        "verificationCode",
        "attemptCount",
        "maxAttempts",
        "isVerified",
        "expiresAt",
        "createdAt",
        "updatedAt",
        "isActive"
      ],
      "primaryKey": "magicLinkVerificationId"
    },
    "clientOnboardingSlideProgress": {
      "tableName": "ClientOnboardingSlideProgress",
      "objectType": "table",
      "fields": {
        "clientOnboardingSlideProgressId": {
          "fieldName": "clientOnboardingSlideProgressId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientOnboardingSlideProgress"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientOnboardingSlideProgress",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "hasClientStartedOnboarding": {
          "fieldName": "hasClientStartedOnboarding",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientOnboardingSlideProgress"
        },
        "hasClientCompletedOnboarding": {
          "fieldName": "hasClientCompletedOnboarding",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientOnboardingSlideProgress"
        }
      },
      "orderedFieldNames": [
        "clientOnboardingSlideProgressId",
        "clientId",
        "hasClientStartedOnboarding",
        "hasClientCompletedOnboarding"
      ],
      "primaryKey": "clientOnboardingSlideProgressId"
    },
    "clientCareEnvironmentCosts": {
      "tableName": "ClientCareEnvironmentCosts",
      "objectType": "table",
      "fields": {
        "clientCareEnvironmentCostId": {
          "fieldName": "clientCareEnvironmentCostId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCareEnvironmentCosts"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCareEnvironmentCosts",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "careEnvironment": {
          "fieldName": "careEnvironment",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCareEnvironmentCosts",
          "referenceTableName": "CareEnvironments",
          "referenceFieldName": "careEnvironmentId"
        },
        "rateAmount": {
          "fieldName": "rateAmount",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCareEnvironmentCosts"
        }
      },
      "orderedFieldNames": [
        "clientCareEnvironmentCostId",
        "clientId",
        "careEnvironment",
        "rateAmount"
      ],
      "primaryKey": "clientCareEnvironmentCostId"
    },
    "emailPreferences": {
      "tableName": "EmailPreferences",
      "objectType": "table",
      "fields": {
        "email": {
          "fieldName": "email",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailPreferences"
        },
        "optOutReminders": {
          "fieldName": "optOutReminders",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "EmailPreferences"
        },
        "optOutTransactions": {
          "fieldName": "optOutTransactions",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "EmailPreferences"
        }
      },
      "orderedFieldNames": [
        "email",
        "optOutReminders",
        "optOutTransactions"
      ],
      "primaryKey": "email"
    },
    "clientCarePhaseDurationSelections": {
      "tableName": "ClientCarePhaseDurationSelections",
      "objectType": "table",
      "fields": {
        "clientCarePhaseDurationSelectionId": {
          "fieldName": "clientCarePhaseDurationSelectionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCarePhaseDurationSelections"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCarePhaseDurationSelections",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "carePhase": {
          "fieldName": "carePhase",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCarePhaseDurationSelections",
          "referenceTableName": "CarePhases",
          "referenceFieldName": "carePhaseId"
        },
        "durationMonths": {
          "fieldName": "durationMonths",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCarePhaseDurationSelections"
        }
      },
      "orderedFieldNames": [
        "clientCarePhaseDurationSelectionId",
        "clientId",
        "carePhase",
        "durationMonths"
      ],
      "primaryKey": "clientCarePhaseDurationSelectionId"
    },
    "clientPolicyDataExtractRequests": {
      "tableName": "ClientPolicyDataExtractRequests",
      "objectType": "table",
      "fields": {
        "requestId": {
          "fieldName": "requestId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "policyType": {
          "fieldName": "policyType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "policyTypeInferenceResponse": {
          "fieldName": "policyTypeInferenceResponse",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "prompt": {
          "fieldName": "prompt",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "error": {
          "fieldName": "error",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "results": {
          "fieldName": "results",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        },
        "responseDateTime": {
          "fieldName": "responseDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyDataExtractRequests"
        }
      },
      "orderedFieldNames": [
        "requestId",
        "clientId",
        "policyType",
        "policyTypeInferenceResponse",
        "prompt",
        "status",
        "error",
        "results",
        "createdDateTime",
        "responseDateTime"
      ],
      "primaryKey": "requestId"
    },
    "openAiCompletionRequests": {
      "tableName": "OpenAiCompletionRequests",
      "objectType": "table",
      "fields": {
        "requestId": {
          "fieldName": "requestId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "requesterId": {
          "fieldName": "requesterId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "requesterType": {
          "fieldName": "requesterType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "aiPromptType": {
          "fieldName": "aiPromptType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "prompt": {
          "fieldName": "prompt",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "userPrompt": {
          "fieldName": "userPrompt",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "model": {
          "fieldName": "model",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "error": {
          "fieldName": "error",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "results": {
          "fieldName": "results",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "finishReason": {
          "fieldName": "finishReason",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "responseDateTime": {
          "fieldName": "responseDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OpenAiCompletionRequests"
        },
        "promptVersion": {
          "fieldName": "promptVersion",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "OpenAiCompletionRequests"
        }
      },
      "orderedFieldNames": [
        "requestId",
        "requesterId",
        "requesterType",
        "aiPromptType",
        "metadata",
        "prompt",
        "userPrompt",
        "model",
        "status",
        "error",
        "results",
        "finishReason",
        "createdDateTime",
        "responseDateTime",
        "promptVersion"
      ],
      "primaryKey": "requestId"
    },
    "illustrationRequests": {
      "tableName": "IllustrationRequests",
      "objectType": "table",
      "fields": {
        "requestId": {
          "fieldName": "requestId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "insuranceQuoteId": {
          "fieldName": "insuranceQuoteId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "zipcode": {
          "fieldName": "zipcode",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "clientData": {
          "fieldName": "clientData",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "partnerData": {
          "fieldName": "partnerData",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "error": {
          "fieldName": "error",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "pdfUrl": {
          "fieldName": "pdfUrl",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "downloaded": {
          "fieldName": "downloaded",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "IllustrationRequests"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "IllustrationRequests"
        },
        "responseDateTime": {
          "fieldName": "responseDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "fileLocation": {
          "fieldName": "fileLocation",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "responseData": {
          "fieldName": "responseData",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests"
        },
        "fundingSourceId": {
          "fieldName": "fundingSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IllustrationRequests",
          "referenceTableName": "FundingSources",
          "referenceFieldName": "fundingSourceId"
        }
      },
      "orderedFieldNames": [
        "requestId",
        "insuranceQuoteId",
        "clientId",
        "zipcode",
        "clientData",
        "partnerData",
        "status",
        "error",
        "pdfUrl",
        "downloaded",
        "createdDateTime",
        "responseDateTime",
        "fileLocation",
        "responseData",
        "fundingSourceId"
      ],
      "primaryKey": "requestId"
    },
    "clientPartnerLinks": {
      "tableName": "ClientPartnerLinks",
      "objectType": "table",
      "fields": {
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPartnerLinks",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "partnerClientId": {
          "fieldName": "partnerClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPartnerLinks",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "coupleId": {
          "fieldName": "coupleId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPartnerLinks"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPartnerLinks"
        }
      },
      "orderedFieldNames": [
        "clientId",
        "partnerClientId",
        "coupleId",
        "createdDateTime"
      ],
      "primaryKey": "clientId"
    },
    "intakeFormPayloads": {
      "tableName": "IntakeFormPayloads",
      "objectType": "table",
      "fields": {
        "typeformPayloadSubmissionId": {
          "fieldName": "typeformPayloadSubmissionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IntakeFormPayloads"
        },
        "typeformPayload": {
          "fieldName": "typeformPayload",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "IntakeFormPayloads"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IntakeFormPayloads"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IntakeFormPayloads"
        },
        "surveyId": {
          "fieldName": "surveyId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "IntakeFormPayloads"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "IntakeFormPayloads"
        }
      },
      "orderedFieldNames": [
        "typeformPayloadSubmissionId",
        "typeformPayload",
        "advisorId",
        "clientId",
        "surveyId",
        "createdDateTime"
      ],
      "primaryKey": "typeformPayloadSubmissionId"
    },
    "formProviderReferences": {
      "tableName": "FormProviderReferences",
      "objectType": "table",
      "fields": {
        "formReferenceId": {
          "fieldName": "formReferenceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "clientEmail": {
          "fieldName": "clientEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "provider": {
          "fieldName": "provider",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        },
        "providerContactId": {
          "fieldName": "providerContactId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "providerSurveyId": {
          "fieldName": "providerSurveyId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "providerEnvironmentId": {
          "fieldName": "providerEnvironmentId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "formLink": {
          "fieldName": "formLink",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "sentAt": {
          "fieldName": "sentAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        },
        "completedAt": {
          "fieldName": "completedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "responseId": {
          "fieldName": "responseId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "FormProviderReferences"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "FormProviderReferences"
        }
      },
      "orderedFieldNames": [
        "formReferenceId",
        "clientId",
        "advisorId",
        "clientEmail",
        "provider",
        "providerContactId",
        "providerSurveyId",
        "providerEnvironmentId",
        "formLink",
        "sentAt",
        "completedAt",
        "responseId",
        "status",
        "metadata",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "formReferenceId"
    },
    "advisorConsents": {
      "tableName": "AdvisorConsents",
      "objectType": "table",
      "fields": {
        "advisorConsentId": {
          "fieldName": "advisorConsentId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorConsents"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorConsents",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "consentText": {
          "fieldName": "consentText",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorConsents"
        },
        "consentVersionDescription": {
          "fieldName": "consentVersionDescription",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorConsents"
        },
        "consentDateTime": {
          "fieldName": "consentDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorConsents"
        }
      },
      "orderedFieldNames": [
        "advisorConsentId",
        "advisorId",
        "consentText",
        "consentVersionDescription",
        "consentDateTime"
      ],
      "primaryKey": "advisorConsentId"
    },
    "clientCustomInferences": {
      "tableName": "ClientCustomInferences",
      "objectType": "table",
      "fields": {
        "clientCustomInferenceId": {
          "fieldName": "clientCustomInferenceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCustomInferences"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCustomInferences",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "inferenceLabel": {
          "fieldName": "inferenceLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCustomInferences"
        },
        "inferenceValue": {
          "fieldName": "inferenceValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCustomInferences"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientCustomInferences"
        }
      },
      "orderedFieldNames": [
        "clientCustomInferenceId",
        "clientId",
        "inferenceLabel",
        "inferenceValue",
        "createdDateTime"
      ],
      "primaryKey": "clientCustomInferenceId"
    },
    "partnerLinkRequests": {
      "tableName": "PartnerLinkRequests",
      "objectType": "table",
      "fields": {
        "partnerLinkRequestId": {
          "fieldName": "partnerLinkRequestId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "partnerClientId": {
          "fieldName": "partnerClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "token": {
          "fieldName": "token",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PartnerLinkRequests"
        },
        "statusDateTime": {
          "fieldName": "statusDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PartnerLinkRequests"
        },
        "unsuccessfulVerificationAttempts": {
          "fieldName": "unsuccessfulVerificationAttempts",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PartnerLinkRequests"
        },
        "expirationDateTime": {
          "fieldName": "expirationDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PartnerLinkRequests"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PartnerLinkRequests"
        }
      },
      "orderedFieldNames": [
        "partnerLinkRequestId",
        "clientId",
        "partnerClientId",
        "advisorId",
        "token",
        "status",
        "statusDateTime",
        "unsuccessfulVerificationAttempts",
        "expirationDateTime",
        "createdDateTime"
      ],
      "primaryKey": "partnerLinkRequestId"
    },
    "advisorHierarchy": {
      "tableName": "AdvisorHierarchy",
      "objectType": "table",
      "fields": {
        "advisorHierarchyId": {
          "fieldName": "advisorHierarchyId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorHierarchy"
        },
        "supervisorAdvisorId": {
          "fieldName": "supervisorAdvisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorHierarchy",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "subordinateAdvisorId": {
          "fieldName": "subordinateAdvisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorHierarchy",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorHierarchy"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorHierarchy"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorHierarchy"
        }
      },
      "orderedFieldNames": [
        "advisorHierarchyId",
        "supervisorAdvisorId",
        "subordinateAdvisorId",
        "isActive",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorHierarchyId"
    },
    "clientCalculationSettings": {
      "tableName": "ClientCalculationSettings",
      "objectType": "table",
      "fields": {
        "clientCalculationSettingsId": {
          "fieldName": "clientCalculationSettingsId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculationSettings"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculationSettings",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "settingLabel": {
          "fieldName": "settingLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculationSettings"
        },
        "settingValue": {
          "fieldName": "settingValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculationSettings"
        },
        "settingType": {
          "fieldName": "settingType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculationSettings"
        }
      },
      "orderedFieldNames": [
        "clientCalculationSettingsId",
        "clientId",
        "settingLabel",
        "settingValue",
        "settingType"
      ],
      "primaryKey": "clientCalculationSettingsId"
    },
    "clientEmailEngagements": {
      "tableName": "ClientEmailEngagements",
      "objectType": "table",
      "fields": {
        "clientEmailEngagementId": {
          "fieldName": "clientEmailEngagementId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "engagementType": {
          "fieldName": "engagementType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements"
        },
        "batchId": {
          "fieldName": "batchId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEmailEngagements"
        }
      },
      "orderedFieldNames": [
        "clientEmailEngagementId",
        "advisorId",
        "clientId",
        "engagementType",
        "createdDateTime",
        "batchId"
      ],
      "primaryKey": "clientEmailEngagementId"
    },
    "emailTransactionLog": {
      "tableName": "EmailTransactionLog",
      "objectType": "table",
      "fields": {
        "emailTransactionLogId": {
          "fieldName": "emailTransactionLogId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "fromEmail": {
          "fieldName": "fromEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "toEmail": {
          "fieldName": "toEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "subject": {
          "fieldName": "subject",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "htmlContent": {
          "fieldName": "htmlContent",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "emailType": {
          "fieldName": "emailType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "errorMessage": {
          "fieldName": "errorMessage",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "messageId": {
          "fieldName": "messageId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog"
        },
        "sentByAdvisorId": {
          "fieldName": "sentByAdvisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "EmailTransactionLog",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "EmailTransactionLog"
        }
      },
      "orderedFieldNames": [
        "emailTransactionLogId",
        "fromEmail",
        "toEmail",
        "subject",
        "htmlContent",
        "emailType",
        "metadata",
        "status",
        "errorMessage",
        "messageId",
        "sentByAdvisorId",
        "createdDateTime"
      ],
      "primaryKey": "emailTransactionLogId"
    },
    "advisorReferralSources": {
      "tableName": "AdvisorReferralSources",
      "objectType": "table",
      "fields": {
        "advisorReferralSourceId": {
          "fieldName": "advisorReferralSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorReferralSources"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorReferralSources",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "referralSourceLabel": {
          "fieldName": "referralSourceLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorReferralSources"
        },
        "createdAtDateTime": {
          "fieldName": "createdAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorReferralSources"
        },
        "updatedAtDateTime": {
          "fieldName": "updatedAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorReferralSources"
        }
      },
      "orderedFieldNames": [
        "advisorReferralSourceId",
        "advisorId",
        "referralSourceLabel",
        "createdAtDateTime",
        "updatedAtDateTime"
      ],
      "primaryKey": "advisorReferralSourceId"
    },
    "clientReferralSources": {
      "tableName": "ClientReferralSources",
      "objectType": "table",
      "fields": {
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientReferralSources",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientReferralSources",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "advisorReferralSourceId": {
          "fieldName": "advisorReferralSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientReferralSources",
          "referenceTableName": "AdvisorReferralSources",
          "referenceFieldName": "advisorReferralSourceId"
        },
        "createdAtDateTime": {
          "fieldName": "createdAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientReferralSources"
        },
        "updatedAtDateTime": {
          "fieldName": "updatedAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientReferralSources"
        }
      },
      "orderedFieldNames": [
        "clientId",
        "advisorId",
        "advisorReferralSourceId",
        "createdAtDateTime",
        "updatedAtDateTime"
      ],
      "primaryKey": "clientId"
    },
    "clientRelationshipStages": {
      "tableName": "ClientRelationshipStages",
      "objectType": "table",
      "fields": {
        "clientRelationshipStageId": {
          "fieldName": "clientRelationshipStageId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientRelationshipStages"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientRelationshipStages",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "relationshipStage": {
          "fieldName": "relationshipStage",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientRelationshipStages"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "ClientRelationshipStages"
        },
        "endedAtDateTime": {
          "fieldName": "endedAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientRelationshipStages"
        },
        "createdAtDateTime": {
          "fieldName": "createdAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientRelationshipStages"
        }
      },
      "orderedFieldNames": [
        "clientRelationshipStageId",
        "clientId",
        "relationshipStage",
        "isActive",
        "endedAtDateTime",
        "createdAtDateTime"
      ],
      "primaryKey": "clientRelationshipStageId"
    },
    "clientCalculations": {
      "tableName": "ClientCalculations",
      "objectType": "table",
      "fields": {
        "clientCalculationId": {
          "fieldName": "clientCalculationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "calculationType": {
          "fieldName": "calculationType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "calculationDateTime": {
          "fieldName": "calculationDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "inputParameters": {
          "fieldName": "inputParameters",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "result": {
          "fieldName": "result",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "version": {
          "fieldName": "version",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        },
        "calculationHash": {
          "fieldName": "calculationHash",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientCalculations"
        }
      },
      "orderedFieldNames": [
        "clientCalculationId",
        "clientId",
        "calculationType",
        "calculationDateTime",
        "inputParameters",
        "result",
        "version",
        "calculationHash"
      ],
      "primaryKey": "clientCalculationId"
    },
    "advisorSettings": {
      "tableName": "AdvisorSettings",
      "objectType": "table",
      "fields": {
        "advisorSettingId": {
          "fieldName": "advisorSettingId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSettings"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSettings",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "settingLabel": {
          "fieldName": "settingLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSettings"
        },
        "settingValue": {
          "fieldName": "settingValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSettings"
        },
        "settingType": {
          "fieldName": "settingType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorSettings"
        },
        "createdAtDateTime": {
          "fieldName": "createdAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorSettings"
        },
        "updatedAtDateTime": {
          "fieldName": "updatedAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorSettings"
        }
      },
      "orderedFieldNames": [
        "advisorSettingId",
        "advisorId",
        "settingLabel",
        "settingValue",
        "settingType",
        "createdAtDateTime",
        "updatedAtDateTime"
      ],
      "primaryKey": "advisorSettingId"
    },
    "quotes": {
      "tableName": "Quotes",
      "objectType": "table",
      "fields": {
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "uniqueHash": {
          "fieldName": "uniqueHash",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "carrierName": {
          "fieldName": "carrierName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "productName": {
          "fieldName": "productName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "stateCategory": {
          "fieldName": "stateCategory",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "lifeIndex": {
          "fieldName": "lifeIndex",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "gender": {
          "fieldName": "gender",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "age": {
          "fieldName": "age",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "tobaccoStatus": {
          "fieldName": "tobaccoStatus",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "productFundingOption": {
          "fieldName": "productFundingOption",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "aobInflation": {
          "fieldName": "aobInflation",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "aobInflationDuration": {
          "fieldName": "aobInflationDuration",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "cobInflation": {
          "fieldName": "cobInflation",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "cobInflationDuration": {
          "fieldName": "cobInflationDuration",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "premiumAmount": {
          "fieldName": "premiumAmount",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "faceAmount": {
          "fieldName": "faceAmount",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "totalLtcBenefitLimitMonthly": {
          "fieldName": "totalLTCBenefitLimitMonthly",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "totalLtcBenefitLimitAnnual": {
          "fieldName": "totalLTCBenefitLimitAnnual",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "singlePayLifePremium": {
          "fieldName": "singlePayLifePremium",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "initialLtcPremium": {
          "fieldName": "initialLTCPremium",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "benefits": {
          "fieldName": "benefits",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "benefitPeriod": {
          "fieldName": "benefitPeriod",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "maximumPremiumInvestment": {
          "fieldName": "maximumPremiumInvestment",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        },
        "minimumPremiumInvestment": {
          "fieldName": "minimumPremiumInvestment",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Quotes"
        }
      },
      "orderedFieldNames": [
        "quoteId",
        "uniqueHash",
        "carrierName",
        "productName",
        "stateCategory",
        "lifeIndex",
        "gender",
        "age",
        "tobaccoStatus",
        "productFundingOption",
        "aobInflation",
        "aobInflationDuration",
        "cobInflation",
        "cobInflationDuration",
        "premiumAmount",
        "faceAmount",
        "totalLTCBenefitLimitMonthly",
        "totalLTCBenefitLimitAnnual",
        "singlePayLifePremium",
        "initialLTCPremium",
        "benefits",
        "benefitPeriod",
        "maximumPremiumInvestment",
        "minimumPremiumInvestment"
      ],
      "primaryKey": "quoteId"
    },
    "insuranceCarriers": {
      "tableName": "InsuranceCarriers",
      "objectType": "table",
      "fields": {
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarriers"
        },
        "name": {
          "fieldName": "name",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarriers"
        },
        "isGloballyAvailableQuotes": {
          "fieldName": "isGloballyAvailableQuotes",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarriers"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarriers"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarriers"
        }
      },
      "orderedFieldNames": [
        "insuranceCarrierId",
        "name",
        "isGloballyAvailableQuotes",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "insuranceCarrierId"
    },
    "insuranceQuotes": {
      "tableName": "InsuranceQuotes",
      "objectType": "table",
      "fields": {
        "insuranceQuoteId": {
          "fieldName": "insuranceQuoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "carrierName": {
          "fieldName": "carrierName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes",
          "referenceTableName": "InsuranceCarriers",
          "referenceFieldName": "insuranceCarrierId"
        },
        "productName": {
          "fieldName": "productName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "productFundingOption": {
          "fieldName": "productFundingOption",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "policyType": {
          "fieldName": "policyType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "usaState": {
          "fieldName": "usaState",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "usaStateCategory": {
          "fieldName": "usaStateCategory",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "primaryGender": {
          "fieldName": "primaryGender",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "primaryAge": {
          "fieldName": "primaryAge",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "primaryTobaccoStatus": {
          "fieldName": "primaryTobaccoStatus",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "secondaryGender": {
          "fieldName": "secondaryGender",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "secondaryAge": {
          "fieldName": "secondaryAge",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "secondaryTobaccoStatus": {
          "fieldName": "secondaryTobaccoStatus",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "premiumAmount": {
          "fieldName": "premiumAmount",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "deathBenefitInitial": {
          "fieldName": "deathBenefitInitial",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "deathBenefitMinimumGuaranteedIndividual": {
          "fieldName": "deathBenefitMinimumGuaranteedIndividual",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "deathBenefitMinimumGuaranteedJoint": {
          "fieldName": "deathBenefitMinimumGuaranteedJoint",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "ltcBenefitMonthlyIndividual": {
          "fieldName": "ltcBenefitMonthlyIndividual",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "ltcBenefitAnnualIndividual": {
          "fieldName": "ltcBenefitAnnualIndividual",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "ltcBenefitTotal": {
          "fieldName": "ltcBenefitTotal",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "ltcBenefitDurationMonths": {
          "fieldName": "ltcBenefitDurationMonths",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "ltcPremium": {
          "fieldName": "ltcPremium",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "lifePremium": {
          "fieldName": "lifePremium",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "maxMonthlyLtcBenefitReimbursement": {
          "fieldName": "maxMonthlyLTCBenefitReimbursement",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "maxMonthlyLtcBenefitIndemnity": {
          "fieldName": "maxMonthlyLTCBenefitIndemnity",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "returnOfPremiumPercent": {
          "fieldName": "returnOfPremiumPercent",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "aobDuration": {
          "fieldName": "aobDuration",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "cobDuration": {
          "fieldName": "cobDuration",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "aobInflation": {
          "fieldName": "aobInflation",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "cobInflation": {
          "fieldName": "cobInflation",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "inflationDuration": {
          "fieldName": "inflationDuration",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "inflationBenefitOption": {
          "fieldName": "inflationBenefitOption",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "cobPaymentOption": {
          "fieldName": "cobPaymentOption",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "investmentMin": {
          "fieldName": "investmentMin",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "investmentMax": {
          "fieldName": "investmentMax",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "notes": {
          "fieldName": "notes",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceQuotes"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceQuotes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceQuotes"
        },
        "fundingPolicyType": {
          "fieldName": "fundingPolicyType",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceQuotes",
          "referenceTableName": "FundingPolicyTypes",
          "referenceFieldName": "fundingPolicyTypeId"
        }
      },
      "orderedFieldNames": [
        "insuranceQuoteId",
        "carrierName",
        "insuranceCarrierId",
        "productName",
        "productFundingOption",
        "policyType",
        "usaState",
        "usaStateCategory",
        "primaryGender",
        "primaryAge",
        "primaryTobaccoStatus",
        "secondaryGender",
        "secondaryAge",
        "secondaryTobaccoStatus",
        "premiumAmount",
        "deathBenefitInitial",
        "deathBenefitMinimumGuaranteedIndividual",
        "deathBenefitMinimumGuaranteedJoint",
        "ltcBenefitMonthlyIndividual",
        "ltcBenefitAnnualIndividual",
        "ltcBenefitTotal",
        "ltcBenefitDurationMonths",
        "ltcPremium",
        "lifePremium",
        "maxMonthlyLTCBenefitReimbursement",
        "maxMonthlyLTCBenefitIndemnity",
        "returnOfPremiumPercent",
        "aobDuration",
        "cobDuration",
        "aobInflation",
        "cobInflation",
        "inflationDuration",
        "inflationBenefitOption",
        "cobPaymentOption",
        "investmentMin",
        "investmentMax",
        "notes",
        "createdDateTime",
        "updatedDateTime",
        "fundingPolicyType"
      ],
      "primaryKey": "insuranceQuoteId"
    },
    "quoteStateAvailability": {
      "tableName": "QuoteStateAvailability",
      "objectType": "table",
      "fields": {
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "QuoteStateAvailability",
          "referenceTableName": "InsuranceQuotes",
          "referenceFieldName": "insuranceQuoteId"
        },
        "state": {
          "fieldName": "state",
          "objectType": "field",
          "sqlType": "CHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "QuoteStateAvailability"
        }
      },
      "orderedFieldNames": [
        "quoteId",
        "state"
      ]
    },
    "oAuthTokens": {
      "tableName": "OAuthTokens",
      "objectType": "table",
      "fields": {
        "oauthTokenId": {
          "fieldName": "oauthTokenId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "userId": {
          "fieldName": "userId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "userEmail": {
          "fieldName": "userEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "provider": {
          "fieldName": "provider",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "accessToken": {
          "fieldName": "accessToken",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "refreshToken": {
          "fieldName": "refreshToken",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "expiresAt": {
          "fieldName": "expiresAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "scope": {
          "fieldName": "scope",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "OAuthTokens"
        },
        "createdAtDateTime": {
          "fieldName": "createdAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "OAuthTokens"
        },
        "updatedAtDateTime": {
          "fieldName": "updatedAtDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "OAuthTokens"
        }
      },
      "orderedFieldNames": [
        "oauthTokenId",
        "userId",
        "userEmail",
        "provider",
        "accessToken",
        "refreshToken",
        "expiresAt",
        "scope",
        "createdAtDateTime",
        "updatedAtDateTime"
      ],
      "primaryKey": "oauthTokenId"
    },
    "advisorAttributes": {
      "tableName": "AdvisorAttributes",
      "objectType": "table",
      "fields": {
        "advisorAttributeId": {
          "fieldName": "advisorAttributeId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAttributes"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorAttributes",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "attributeLabel": {
          "fieldName": "attributeLabel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorAttributes"
        },
        "attributeValue": {
          "fieldName": "attributeValue",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorAttributes"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAttributes"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAttributes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAttributes"
        }
      },
      "orderedFieldNames": [
        "advisorAttributeId",
        "advisorId",
        "attributeLabel",
        "attributeValue",
        "isActive",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorAttributeId"
    },
    "policyApplicationForms": {
      "tableName": "PolicyApplicationForms",
      "objectType": "table",
      "fields": {
        "policyApplicationFormId": {
          "fieldName": "policyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationForms"
        },
        "formTitle": {
          "fieldName": "formTitle",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationForms"
        },
        "formType": {
          "fieldName": "formType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationForms"
        },
        "carrierName": {
          "fieldName": "carrierName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationForms"
        },
        "productName": {
          "fieldName": "productName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationForms"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationForms"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationForms"
        }
      },
      "orderedFieldNames": [
        "policyApplicationFormId",
        "formTitle",
        "formType",
        "carrierName",
        "productName",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "policyApplicationFormId"
    },
    "clientPolicyApplications": {
      "tableName": "ClientPolicyApplications",
      "objectType": "table",
      "fields": {
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplications"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplications",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "partnerClientId": {
          "fieldName": "partnerClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplications",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "fundingPolicyType": {
          "fieldName": "fundingPolicyType",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplications"
        },
        "fundingSourceId": {
          "fieldName": "fundingSourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplications",
          "referenceTableName": "FundingSources",
          "referenceFieldName": "fundingSourceId"
        },
        "stateOfResidenceAbbreviation": {
          "fieldName": "stateOfResidenceAbbreviation",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplications"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplications"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplications"
        }
      },
      "orderedFieldNames": [
        "clientPolicyApplicationId",
        "clientId",
        "partnerClientId",
        "fundingPolicyType",
        "fundingSourceId",
        "stateOfResidenceAbbreviation",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "clientPolicyApplicationId"
    },
    "clientPolicyApplicationForms": {
      "tableName": "ClientPolicyApplicationForms",
      "objectType": "table",
      "fields": {
        "clientPolicyApplicationFormId": {
          "fieldName": "clientPolicyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "policyApplicationFormId": {
          "fieldName": "policyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "forClientId": {
          "fieldName": "forClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "submissionData": {
          "fieldName": "submissionData",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "visitedSubsections": {
          "fieldName": "visitedSubsections",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "submittedToEmail": {
          "fieldName": "submittedToEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "submissionDateTime": {
          "fieldName": "submissionDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "prefillAnswers": {
          "fieldName": "prefillAnswers",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "prefillCitations": {
          "fieldName": "prefillCitations",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        },
        "nigoAnalysis": {
          "fieldName": "nigoAnalysis",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationForms"
        }
      },
      "orderedFieldNames": [
        "clientPolicyApplicationFormId",
        "clientPolicyApplicationId",
        "policyApplicationFormId",
        "forClientId",
        "submissionData",
        "visitedSubsections",
        "status",
        "createdDateTime",
        "updatedDateTime",
        "submittedToEmail",
        "submissionDateTime",
        "prefillAnswers",
        "prefillCitations",
        "nigoAnalysis"
      ],
      "primaryKey": "clientPolicyApplicationFormId"
    },
    "clientPolicyApplicationSteps": {
      "tableName": "ClientPolicyApplicationSteps",
      "objectType": "table",
      "fields": {
        "clientPolicyApplicationStepId": {
          "fieldName": "clientPolicyApplicationStepId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationSteps"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "stepType": {
          "fieldName": "stepType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps"
        },
        "stepNumber": {
          "fieldName": "stepNumber",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationSteps"
        },
        "clientPolicyApplicationFormId": {
          "fieldName": "clientPolicyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps",
          "referenceTableName": "ClientPolicyApplicationForms",
          "referenceFieldName": "clientPolicyApplicationFormId"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationSteps"
        }
      },
      "orderedFieldNames": [
        "clientPolicyApplicationStepId",
        "clientPolicyApplicationId",
        "stepType",
        "status",
        "stepNumber",
        "createdDateTime",
        "clientPolicyApplicationFormId",
        "metadata"
      ],
      "primaryKey": "clientPolicyApplicationStepId"
    },
    "clientPolicyApplicationConsents": {
      "tableName": "ClientPolicyApplicationConsents",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationConsents"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationConsents",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationConsents",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationConsents",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "clientPartnerId": {
          "fieldName": "clientPartnerId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyApplicationConsents",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationConsents"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyApplicationConsents"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientPolicyApplicationId",
        "advisorId",
        "clientId",
        "clientPartnerId",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "consents": {
      "tableName": "Consents",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "title": {
          "fieldName": "title",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "description": {
          "fieldName": "description",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "version": {
          "fieldName": "version",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "checkbox": {
          "fieldName": "checkbox",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "date": {
          "fieldName": "date",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Consents"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Consents"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Consents"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Consents"
        }
      },
      "orderedFieldNames": [
        "id",
        "title",
        "description",
        "version",
        "checkbox",
        "date",
        "metadata",
        "createdAt",
        "updatedAt"
      ]
    },
    "consentRecords": {
      "tableName": "ConsentRecords",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "resourceId": {
          "fieldName": "resourceId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "resourceType": {
          "fieldName": "resourceType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "userId": {
          "fieldName": "userId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "userType": {
          "fieldName": "userType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "consentId": {
          "fieldName": "consentId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords",
          "referenceTableName": "Consents",
          "referenceFieldName": "id"
        },
        "hasConsented": {
          "fieldName": "hasConsented",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ConsentRecords"
        },
        "ipAddress": {
          "fieldName": "ipAddress",
          "objectType": "field",
          "sqlType": "INET",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "userAgent": {
          "fieldName": "userAgent",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ConsentRecords"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "ConsentRecords"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ConsentRecords"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ConsentRecords"
        }
      },
      "orderedFieldNames": [
        "id",
        "resourceId",
        "resourceType",
        "userId",
        "userType",
        "consentId",
        "hasConsented",
        "ipAddress",
        "userAgent",
        "metadata",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "deletedClientsConsents": {
      "tableName": "DeletedClientsConsents",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClientsConsents"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClientsConsents"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClientsConsents",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DeletedClientsConsents"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DeletedClientsConsents"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientId",
        "advisorId",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "docuSignPolicyApplicationEnvelopes": {
      "tableName": "DocuSignPolicyApplicationEnvelopes",
      "objectType": "table",
      "fields": {
        "docusignPolicyApplicationEnvelopeId": {
          "fieldName": "docusignPolicyApplicationEnvelopeId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "envelopeId": {
          "fieldName": "envelopeId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "policyApplicationFormId": {
          "fieldName": "policyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "forClientId": {
          "fieldName": "forClientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes",
          "referenceTableName": "Clients",
          "referenceFieldName": "clientId"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        },
        "docusignWebhookData": {
          "fieldName": "docusignWebhookData",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DocuSignPolicyApplicationEnvelopes"
        }
      },
      "orderedFieldNames": [
        "docusignPolicyApplicationEnvelopeId",
        "envelopeId",
        "clientPolicyApplicationId",
        "policyApplicationFormId",
        "forClientId",
        "status",
        "createdDateTime",
        "updatedDateTime",
        "docusignWebhookData"
      ],
      "primaryKey": "docusignPolicyApplicationEnvelopeId"
    },
    "advisorOrganizations": {
      "tableName": "AdvisorOrganizations",
      "objectType": "table",
      "fields": {
        "advisorOrganizationId": {
          "fieldName": "advisorOrganizationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOrganizations"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorOrganizations",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "name": {
          "fieldName": "name",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorOrganizations"
        },
        "contactEmail": {
          "fieldName": "contactEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorOrganizations"
        },
        "type": {
          "fieldName": "type",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorOrganizations"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOrganizations"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOrganizations"
        }
      },
      "orderedFieldNames": [
        "advisorOrganizationId",
        "advisorId",
        "name",
        "contactEmail",
        "type",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorOrganizationId"
    },
    "traditionalLtcQuotes": {
      "tableName": "TraditionalLTCQuotes",
      "objectType": "table",
      "fields": {
        "traditionalLtcQuoteId": {
          "fieldName": "traditionalLTCQuoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes",
          "referenceTableName": "InsuranceCarriers",
          "referenceFieldName": "insuranceCarrierId"
        },
        "carrier": {
          "fieldName": "carrier",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "productName": {
          "fieldName": "productName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "state": {
          "fieldName": "state",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "primaryGender": {
          "fieldName": "primaryGender",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "primaryAge": {
          "fieldName": "primaryAge",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "maritalClass": {
          "fieldName": "maritalClass",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "underwritingClass": {
          "fieldName": "underwritingClass",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "productId": {
          "fieldName": "productId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "benefitPool": {
          "fieldName": "benefitPool",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "dailyBenefitAmount": {
          "fieldName": "dailyBenefitAmount",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "eliminationPeriod": {
          "fieldName": "eliminationPeriod",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "bioPercent": {
          "fieldName": "bioPercent",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "premiumFrequency": {
          "fieldName": "premiumFrequency",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "dp1Rider": {
          "fieldName": "dp1Rider",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "nfoRider": {
          "fieldName": "nfoRider",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "primaryModalPremium": {
          "fieldName": "primaryModalPremium",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "primaryTotalYearlyPremium": {
          "fieldName": "primaryTotalYearlyPremium",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "primaryBenefitType": {
          "fieldName": "primaryBenefitType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuotes"
        },
        "fundingPolicyType": {
          "fieldName": "fundingPolicyType",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "TraditionalLTCQuotes",
          "referenceTableName": "FundingPolicyTypes",
          "referenceFieldName": "fundingPolicyTypeId"
        }
      },
      "orderedFieldNames": [
        "traditionalLTCQuoteId",
        "insuranceCarrierId",
        "carrier",
        "productName",
        "state",
        "primaryGender",
        "primaryAge",
        "maritalClass",
        "underwritingClass",
        "productId",
        "benefitPool",
        "dailyBenefitAmount",
        "eliminationPeriod",
        "bioPercent",
        "premiumFrequency",
        "dp1Rider",
        "nfoRider",
        "primaryModalPremium",
        "primaryTotalYearlyPremium",
        "primaryBenefitType",
        "fundingPolicyType"
      ],
      "primaryKey": "traditionalLTCQuoteId"
    },
    "traditionalLtcQuoteStateAvailability": {
      "tableName": "TraditionalLTCQuoteStateAvailability",
      "objectType": "table",
      "fields": {
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuoteStateAvailability",
          "referenceTableName": "TraditionalLTCQuotes",
          "referenceFieldName": "traditionalLTCQuoteId"
        },
        "state": {
          "fieldName": "state",
          "objectType": "field",
          "sqlType": "CHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "TraditionalLTCQuoteStateAvailability"
        }
      },
      "orderedFieldNames": [
        "quoteId",
        "state"
      ]
    },
    "advisorAddresses": {
      "tableName": "AdvisorAddresses",
      "objectType": "table",
      "fields": {
        "advisorAddressId": {
          "fieldName": "advisorAddressId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAddresses"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "addressType": {
          "fieldName": "addressType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "streetAddress": {
          "fieldName": "streetAddress",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "apartment": {
          "fieldName": "apartment",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "city": {
          "fieldName": "city",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "state": {
          "fieldName": "state",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "zipCode": {
          "fieldName": "zipCode",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorAddresses"
        },
        "country": {
          "fieldName": "country",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "AdvisorAddresses"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAddresses"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorAddresses"
        }
      },
      "orderedFieldNames": [
        "advisorAddressId",
        "advisorId",
        "addressType",
        "streetAddress",
        "apartment",
        "city",
        "state",
        "zipCode",
        "country",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorAddressId"
    },
    "policyApplicationRemarksOverflow": {
      "tableName": "PolicyApplicationRemarksOverflow",
      "objectType": "table",
      "fields": {
        "overflowId": {
          "fieldName": "overflowId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationRemarksOverflow"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationRemarksOverflow",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "policyApplicationFormId": {
          "fieldName": "policyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationRemarksOverflow"
        },
        "questionRef": {
          "fieldName": "questionRef",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationRemarksOverflow"
        },
        "s3Key": {
          "fieldName": "s3Key",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationRemarksOverflow"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationRemarksOverflow"
        }
      },
      "orderedFieldNames": [
        "overflowId",
        "clientPolicyApplicationId",
        "policyApplicationFormId",
        "questionRef",
        "s3Key",
        "createdDateTime"
      ],
      "primaryKey": "overflowId"
    },
    "advisorBgaCarrierLinks": {
      "tableName": "AdvisorBgaCarrierLinks",
      "objectType": "table",
      "fields": {
        "advisorBgaCarrierLinkId": {
          "fieldName": "advisorBgaCarrierLinkId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorBgaCarrierLinks"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorBgaCarrierLinks",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "advisorOrganizationId": {
          "fieldName": "advisorOrganizationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorBgaCarrierLinks",
          "referenceTableName": "AdvisorOrganizations",
          "referenceFieldName": "advisorOrganizationId"
        },
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorBgaCarrierLinks",
          "referenceTableName": "InsuranceCarriers",
          "referenceFieldName": "insuranceCarrierId"
        },
        "writingNumber": {
          "fieldName": "writingNumber",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "AdvisorBgaCarrierLinks"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorBgaCarrierLinks"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorBgaCarrierLinks"
        }
      },
      "orderedFieldNames": [
        "advisorBgaCarrierLinkId",
        "advisorId",
        "advisorOrganizationId",
        "insuranceCarrierId",
        "writingNumber",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorBgaCarrierLinkId"
    },
    "advisorCarrierPolicyTypes": {
      "tableName": "AdvisorCarrierPolicyTypes",
      "objectType": "table",
      "fields": {
        "advisorCarrierPolicyTypeId": {
          "fieldName": "advisorCarrierPolicyTypeId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorCarrierPolicyTypes"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorCarrierPolicyTypes",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorCarrierPolicyTypes",
          "referenceTableName": "InsuranceCarriers",
          "referenceFieldName": "insuranceCarrierId"
        },
        "fundingPolicyTypeId": {
          "fieldName": "fundingPolicyTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorCarrierPolicyTypes",
          "referenceTableName": "FundingPolicyTypes",
          "referenceFieldName": "fundingPolicyTypeId"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorCarrierPolicyTypes"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorCarrierPolicyTypes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorCarrierPolicyTypes"
        }
      },
      "orderedFieldNames": [
        "advisorCarrierPolicyTypeId",
        "advisorId",
        "insuranceCarrierId",
        "fundingPolicyTypeId",
        "isActive",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "advisorCarrierPolicyTypeId"
    },
    "deletedClients": {
      "tableName": "DeletedClients",
      "objectType": "table",
      "fields": {
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClients"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClients",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "clientFirstName": {
          "fieldName": "clientFirstName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DeletedClients"
        },
        "clientLastName": {
          "fieldName": "clientLastName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DeletedClients"
        },
        "clientEmail": {
          "fieldName": "clientEmail",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DeletedClients"
        },
        "deletedDateTime": {
          "fieldName": "deletedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DeletedClients"
        }
      },
      "orderedFieldNames": [
        "clientId",
        "advisorId",
        "clientFirstName",
        "clientLastName",
        "clientEmail",
        "deletedDateTime"
      ],
      "primaryKey": "clientId"
    },
    "zipCareCosts": {
      "tableName": "ZipCareCosts",
      "objectType": "table",
      "fields": {
        "zipCareCostId": {
          "fieldName": "zipCareCostId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ZipCareCosts"
        },
        "zipCode": {
          "fieldName": "zipCode",
          "objectType": "field",
          "sqlType": "CHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ZipCareCosts"
        },
        "careEnvironment": {
          "fieldName": "careEnvironment",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ZipCareCosts",
          "referenceTableName": "CareEnvironments",
          "referenceFieldName": "careEnvironmentId"
        },
        "ratePeriod": {
          "fieldName": "ratePeriod",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ZipCareCosts"
        },
        "rateAmount": {
          "fieldName": "rateAmount",
          "objectType": "field",
          "sqlType": "NUMERIC",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ZipCareCosts"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ZipCareCosts"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ZipCareCosts"
        }
      },
      "orderedFieldNames": [
        "zipCareCostId",
        "zipCode",
        "careEnvironment",
        "ratePeriod",
        "rateAmount",
        "updatedDateTime",
        "createdDateTime"
      ],
      "primaryKey": "zipCareCostId"
    },
    "clientPolicyConsentNotificationLogs": {
      "tableName": "ClientPolicyConsentNotificationLogs",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "sourceMessageTrackingId": {
          "fieldName": "sourceMessageTrackingId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "userId": {
          "fieldName": "userId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "userType": {
          "fieldName": "userType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "requestType": {
          "fieldName": "requestType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "consentType": {
          "fieldName": "consentType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "channel": {
          "fieldName": "channel",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientPolicyConsentNotificationLogs"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientPolicyApplicationId",
        "sourceMessageTrackingId",
        "userId",
        "userType",
        "requestType",
        "consentType",
        "channel",
        "status",
        "metadata",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "communicationLogs": {
      "tableName": "CommunicationLogs",
      "objectType": "table",
      "fields": {
        "eventId": {
          "fieldName": "eventId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        },
        "messageId": {
          "fieldName": "messageId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CommunicationLogs"
        },
        "channel": {
          "fieldName": "channel",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CommunicationLogs"
        },
        "source": {
          "fieldName": "source",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "CommunicationLogs"
        },
        "sourceTrackingId": {
          "fieldName": "sourceTrackingId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "CommunicationLogs"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        },
        "error": {
          "fieldName": "error",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "CommunicationLogs"
        }
      },
      "orderedFieldNames": [
        "eventId",
        "messageId",
        "channel",
        "source",
        "sourceTrackingId",
        "status",
        "metadata",
        "error",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "eventId"
    },
    "genworthSftpLogs": {
      "tableName": "GenworthSftpLogs",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "GenworthSftpLogs"
        },
        "eventId": {
          "fieldName": "eventId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "GenworthSftpLogs"
        },
        "messageId": {
          "fieldName": "messageId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "GenworthSftpLogs"
        },
        "deliveryType": {
          "fieldName": "deliveryType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "GenworthSftpLogs"
        },
        "clientPolicyApplicationId": {
          "fieldName": "clientPolicyApplicationId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "GenworthSftpLogs",
          "referenceTableName": "ClientPolicyApplications",
          "referenceFieldName": "clientPolicyApplicationId"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "GenworthSftpLogs"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "GenworthSftpLogs"
        },
        "error": {
          "fieldName": "error",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "GenworthSftpLogs"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "GenworthSftpLogs"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "GenworthSftpLogs"
        }
      },
      "orderedFieldNames": [
        "id",
        "eventId",
        "messageId",
        "deliveryType",
        "clientPolicyApplicationId",
        "status",
        "metadata",
        "error",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "clientEligibleQuotes": {
      "tableName": "ClientEligibleQuotes",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleQuotes"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientEligibleQuotes"
        },
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEligibleQuotes",
          "referenceTableName": "InsuranceQuotes",
          "referenceFieldName": "insuranceQuoteId"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleQuotes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleQuotes"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientId",
        "quoteId",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "id"
    },
    "clientEligibleTraditionalLtcQuotes": {
      "tableName": "ClientEligibleTraditionalLTCQuotes",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleTraditionalLTCQuotes"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientEligibleTraditionalLTCQuotes"
        },
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientEligibleTraditionalLTCQuotes",
          "referenceTableName": "TraditionalLTCQuotes",
          "referenceFieldName": "traditionalLTCQuoteId"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleTraditionalLTCQuotes"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientEligibleTraditionalLTCQuotes"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientId",
        "quoteId",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "id"
    },
    "clientQuoteProjections": {
      "tableName": "ClientQuoteProjections",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientQuoteProjections"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "policyType": {
          "fieldName": "policyType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "quoteId": {
          "fieldName": "quoteId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "roi": {
          "fieldName": "roi",
          "objectType": "field",
          "sqlType": "FLOAT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "projectedCompoundAnnualGrowthRate": {
          "fieldName": "projectedCompoundAnnualGrowthRate",
          "objectType": "field",
          "sqlType": "FLOAT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "projectedInternalRateOfReturn": {
          "fieldName": "projectedInternalRateOfReturn",
          "objectType": "field",
          "sqlType": "FLOAT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "investmentPeriodYears": {
          "fieldName": "investmentPeriodYears",
          "objectType": "field",
          "sqlType": "FLOAT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "projectedCostCoverage": {
          "fieldName": "projectedCostCoverage",
          "objectType": "field",
          "sqlType": "FLOAT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "ClientQuoteProjections"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientQuoteProjections"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "ClientQuoteProjections"
        }
      },
      "orderedFieldNames": [
        "id",
        "clientId",
        "policyType",
        "quoteId",
        "roi",
        "projectedCompoundAnnualGrowthRate",
        "projectedInternalRateOfReturn",
        "investmentPeriodYears",
        "projectedCostCoverage",
        "createdDateTime",
        "updatedDateTime"
      ],
      "primaryKey": "id"
    },
    "insuranceCarrierProducts": {
      "tableName": "InsuranceCarrierProducts",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProducts"
        },
        "insuranceCarrierId": {
          "fieldName": "insuranceCarrierId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProducts",
          "referenceTableName": "InsuranceCarriers",
          "referenceFieldName": "insuranceCarrierId"
        },
        "name": {
          "fieldName": "name",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProducts"
        },
        "roleKeys": {
          "fieldName": "roleKeys",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProducts"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProducts"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProducts"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProducts"
        }
      },
      "orderedFieldNames": [
        "id",
        "insuranceCarrierId",
        "name",
        "roleKeys",
        "status",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "docusignTemplates": {
      "tableName": "DocusignTemplates",
      "objectType": "table",
      "fields": {
        "templateId": {
          "fieldName": "templateId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocusignTemplates"
        },
        "docusignTemplateId": {
          "fieldName": "docusignTemplateId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "docuSignAccountId": {
          "fieldName": "docuSignAccountId",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "name": {
          "fieldName": "name",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "description": {
          "fieldName": "description",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "version": {
          "fieldName": "version",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocusignTemplates"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "DocusignTemplates"
        },
        "deletedAt": {
          "fieldName": "deletedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "DocusignTemplates"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocusignTemplates"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "DocusignTemplates"
        }
      },
      "orderedFieldNames": [
        "templateId",
        "docusignTemplateId",
        "docuSignAccountId",
        "name",
        "description",
        "version",
        "status",
        "metadata",
        "deletedAt",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "templateId"
    },
    "policyApplicationFormTemplates": {
      "tableName": "PolicyApplicationFormTemplates",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "formName": {
          "fieldName": "formName",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "formTitle": {
          "fieldName": "formTitle",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "formType": {
          "fieldName": "formType",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "requiredParameters": {
          "fieldName": "requiredParameters",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormTemplates"
        },
        "updatedDateTime": {
          "fieldName": "updatedDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormTemplates"
        }
      },
      "orderedFieldNames": [
        "id",
        "formName",
        "formTitle",
        "formType",
        "requiredParameters",
        "createdDateTime",
        "updatedDateTime"
      ]
    },
    "policyApplicationFormSections": {
      "tableName": "PolicyApplicationFormSections",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "formId": {
          "fieldName": "formId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections",
          "referenceTableName": "PolicyApplicationFormTemplates",
          "referenceFieldName": "id"
        },
        "parentSectionId": {
          "fieldName": "parentSectionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections",
          "referenceTableName": "PolicyApplicationFormSections",
          "referenceFieldName": "id"
        },
        "sectionId": {
          "fieldName": "sectionId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "title": {
          "fieldName": "title",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "sectionType": {
          "fieldName": "sectionType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "displayOrder": {
          "fieldName": "displayOrder",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "conditional": {
          "fieldName": "conditional",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormSections"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormSections"
        }
      },
      "orderedFieldNames": [
        "id",
        "formId",
        "parentSectionId",
        "sectionId",
        "title",
        "sectionType",
        "displayOrder",
        "isActive",
        "conditional",
        "createdDateTime"
      ],
      "primaryKey": "id"
    },
    "policyApplicationFormQuestionGroups": {
      "tableName": "PolicyApplicationFormQuestionGroups",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "sectionId": {
          "fieldName": "sectionId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups",
          "referenceTableName": "PolicyApplicationFormSections",
          "referenceFieldName": "id"
        },
        "questionGroupId": {
          "fieldName": "questionGroupId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "className": {
          "fieldName": "className",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "title": {
          "fieldName": "title",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "description": {
          "fieldName": "description",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "format": {
          "fieldName": "format",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "align": {
          "fieldName": "align",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "displayOrder": {
          "fieldName": "displayOrder",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "hidden": {
          "fieldName": "hidden",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "conditional": {
          "fieldName": "conditional",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestionGroups"
        }
      },
      "orderedFieldNames": [
        "id",
        "sectionId",
        "questionGroupId",
        "className",
        "title",
        "description",
        "format",
        "align",
        "displayOrder",
        "isActive",
        "hidden",
        "conditional",
        "createdDateTime"
      ],
      "primaryKey": "id"
    },
    "policyApplicationFormQuestions": {
      "tableName": "PolicyApplicationFormQuestions",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "questionGroupId": {
          "fieldName": "questionGroupId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions",
          "referenceTableName": "PolicyApplicationFormQuestionGroups",
          "referenceFieldName": "id"
        },
        "questionId": {
          "fieldName": "questionId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "questionRef": {
          "fieldName": "questionRef",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "title": {
          "fieldName": "title",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "titleOverride": {
          "fieldName": "titleOverride",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "conditionalTitle": {
          "fieldName": "conditionalTitle",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "type": {
          "fieldName": "type",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "required": {
          "fieldName": "required",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "placeholder": {
          "fieldName": "placeholder",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "helperText": {
          "fieldName": "helperText",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "conditionalHelperText": {
          "fieldName": "conditionalHelperText",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "validationType": {
          "fieldName": "validationType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "displayOrder": {
          "fieldName": "displayOrder",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "isActive": {
          "fieldName": "isActive",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "docusignTabId": {
          "fieldName": "docusignTabId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "docusignPageNumber": {
          "fieldName": "docusignPageNumber",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "docusignTabType": {
          "fieldName": "docusignTabType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "disabled": {
          "fieldName": "disabled",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "hidden": {
          "fieldName": "hidden",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "overflow": {
          "fieldName": "overflow",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "parser": {
          "fieldName": "parser",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "format": {
          "fieldName": "format",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "gridColumns": {
          "fieldName": "gridColumns",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "minRows": {
          "fieldName": "minRows",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "maxRows": {
          "fieldName": "maxRows",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "options": {
          "fieldName": "options",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "columns": {
          "fieldName": "columns",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "conditional": {
          "fieldName": "conditional",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "characterLimit": {
          "fieldName": "characterLimit",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "composite": {
          "fieldName": "composite",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        },
        "createdDateTime": {
          "fieldName": "createdDateTime",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationFormQuestions"
        }
      },
      "orderedFieldNames": [
        "id",
        "questionGroupId",
        "questionId",
        "questionRef",
        "title",
        "titleOverride",
        "conditionalTitle",
        "type",
        "required",
        "placeholder",
        "helperText",
        "conditionalHelperText",
        "validationType",
        "displayOrder",
        "isActive",
        "docusignTabId",
        "docusignPageNumber",
        "docusignTabType",
        "disabled",
        "hidden",
        "overflow",
        "parser",
        "format",
        "gridColumns",
        "minRows",
        "maxRows",
        "options",
        "columns",
        "conditional",
        "characterLimit",
        "composite",
        "createdDateTime"
      ],
      "primaryKey": "id"
    },
    "insuranceCarrierProductPolicyApplicationForms": {
      "tableName": "InsuranceCarrierProductPolicyApplicationForms",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "formId": {
          "fieldName": "formId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms",
          "referenceTableName": "PolicyApplicationFormTemplates",
          "referenceFieldName": "id"
        },
        "insuranceCarrierProductId": {
          "fieldName": "insuranceCarrierProductId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms",
          "referenceTableName": "InsuranceCarrierProducts",
          "referenceFieldName": "id"
        },
        "stateCode": {
          "fieldName": "stateCode",
          "objectType": "field",
          "sqlType": "CHAR",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "fundingPolicyTypeId": {
          "fieldName": "fundingPolicyTypeId",
          "objectType": "field",
          "sqlType": "INT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "type": {
          "fieldName": "type",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "title": {
          "fieldName": "title",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "templateName": {
          "fieldName": "templateName",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "InsuranceCarrierProductPolicyApplicationForms"
        }
      },
      "orderedFieldNames": [
        "id",
        "formId",
        "insuranceCarrierProductId",
        "stateCode",
        "fundingPolicyTypeId",
        "type",
        "title",
        "templateName",
        "status",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "userOnboardingEngagementLogs": {
      "tableName": "UserOnboardingEngagementLogs",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "UserOnboardingEngagementLogs"
        },
        "userType": {
          "fieldName": "userType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "UserOnboardingEngagementLogs"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "UserOnboardingEngagementLogs"
        },
        "clientId": {
          "fieldName": "clientId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "UserOnboardingEngagementLogs"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "UserOnboardingEngagementLogs"
        }
      },
      "orderedFieldNames": [
        "id",
        "userType",
        "advisorId",
        "clientId",
        "createdAt"
      ],
      "primaryKey": "id"
    },
    "policyApplicationTemplateConfiguration": {
      "tableName": "PolicyApplicationTemplateConfiguration",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "insuranceCarrierProductPolicyApplicationFormId": {
          "fieldName": "insuranceCarrierProductPolicyApplicationFormId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "templateName": {
          "fieldName": "templateName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "defaultSequence": {
          "fieldName": "defaultSequence",
          "objectType": "field",
          "sqlType": "INTEGER",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "isRequired": {
          "fieldName": "isRequired",
          "objectType": "field",
          "sqlType": "BOOLEAN",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "allowedRoles": {
          "fieldName": "allowedRoles",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "conditional": {
          "fieldName": "conditional",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "metadata": {
          "fieldName": "metadata",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "status": {
          "fieldName": "status",
          "objectType": "field",
          "sqlType": "VARCHAR",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "PolicyApplicationTemplateConfiguration"
        }
      },
      "orderedFieldNames": [
        "id",
        "insuranceCarrierProductPolicyApplicationFormId",
        "templateName",
        "defaultSequence",
        "isRequired",
        "allowedRoles",
        "conditional",
        "metadata",
        "status",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "advisorOnboardingCompletedSteps": {
      "tableName": "AdvisorOnboardingCompletedSteps",
      "objectType": "table",
      "fields": {
        "id": {
          "fieldName": "id",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOnboardingCompletedSteps"
        },
        "advisorId": {
          "fieldName": "advisorId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "AdvisorOnboardingCompletedSteps",
          "referenceTableName": "Advisors",
          "referenceFieldName": "advisorId"
        },
        "completedSteps": {
          "fieldName": "completedSteps",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOnboardingCompletedSteps"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOnboardingCompletedSteps"
        },
        "updatedAt": {
          "fieldName": "updatedAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "AdvisorOnboardingCompletedSteps"
        }
      },
      "orderedFieldNames": [
        "id",
        "advisorId",
        "completedSteps",
        "createdAt",
        "updatedAt"
      ],
      "primaryKey": "id"
    },
    "events": {
      "tableName": "Events",
      "objectType": "table",
      "fields": {
        "eventId": {
          "fieldName": "eventId",
          "objectType": "field",
          "sqlType": "UUID",
          "isPrimaryKey": true,
          "isRequired": true,
          "hasDefault": true,
          "ownerTableName": "Events"
        },
        "eventName": {
          "fieldName": "eventName",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "eventCategory": {
          "fieldName": "eventCategory",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "userId": {
          "fieldName": "userId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "userType": {
          "fieldName": "userType",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "sessionId": {
          "fieldName": "sessionId",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "timestamp": {
          "fieldName": "timestamp",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": true,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "pageUrl": {
          "fieldName": "pageUrl",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "pagePath": {
          "fieldName": "pagePath",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "pageTitle": {
          "fieldName": "pageTitle",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "referrer": {
          "fieldName": "referrer",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "properties": {
          "fieldName": "properties",
          "objectType": "field",
          "sqlType": "JSONB",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Events"
        },
        "userAgent": {
          "fieldName": "userAgent",
          "objectType": "field",
          "sqlType": "TEXT",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "ipAddress": {
          "fieldName": "ipAddress",
          "objectType": "field",
          "sqlType": "INET",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": false,
          "ownerTableName": "Events"
        },
        "createdAt": {
          "fieldName": "createdAt",
          "objectType": "field",
          "sqlType": "TIMESTAMP",
          "isPrimaryKey": false,
          "isRequired": false,
          "hasDefault": true,
          "ownerTableName": "Events"
        }
      },
      "orderedFieldNames": [
        "eventId",
        "eventName",
        "eventCategory",
        "userId",
        "userType",
        "sessionId",
        "timestamp",
        "pageUrl",
        "pagePath",
        "pageTitle",
        "referrer",
        "properties",
        "userAgent",
        "ipAddress",
        "createdAt"
      ],
      "primaryKey": "eventId"
    }
  },
  "dependencyOrderedTableNames": [
    "WalpSchemaVersion",
    "CareEnvironments",
    "CarePhases",
    "ClientStatuses",
    "ClientTagDefs",
    "FundingPolicyTypes",
    "AnnuityTypes",
    "SupportProviderContributions",
    "SupportProviderDetailSetSources",
    "SupportProviderTypes",
    "SurveyQuestionTypes",
    "SurveyStatuses",
    "SurveySubmitters",
    "Advisors",
    "StripeCustomer",
    "StripeSubscriptions",
    "Sponsorships",
    "SponsorshipActivities",
    "SponsorshipActivityTypes",
    "AdvisorSponsorshipActivities",
    "AdvisorSponsorshipStatuses",
    "AdvisorSponsorships",
    "AdvisorStripeSubscriptions",
    "SubscriptionSeats",
    "ClientAuthUsers",
    "Clients",
    "ClientTags",
    "CareEnvironmentSelections",
    "SupportProviders",
    "SupportProviderDetailSets",
    "SupportProviderDetails",
    "SurveyDefinitions",
    "SurveyQuestions",
    "Surveys",
    "SurveyAnswers",
    "InferenceSets",
    "FundingSources",
    "FundingSourceDetails",
    "MagicLinks",
    "MagicLinkVerificationCodes",
    "ClientOnboardingSlideProgress",
    "ClientCareEnvironmentCosts",
    "EmailPreferences",
    "ClientCarePhaseDurationSelections",
    "ClientPolicyDataExtractRequests",
    "OpenAiCompletionRequests",
    "IllustrationRequests",
    "ClientPartnerLinks",
    "IntakeFormPayloads",
    "AdvisorConsents",
    "ClientCustomInferences",
    "PartnerLinkRequests",
    "AdvisorHierarchy",
    "ClientCalculationSettings",
    "ClientEmailEngagements",
    "EmailTransactionLog",
    "AdvisorReferralSources",
    "ClientReferralSources",
    "ClientRelationshipStages",
    "ClientCalculations",
    "AdvisorSettings",
    "Quotes",
    "InsuranceCarriers",
    "InsuranceQuotes",
    "QuoteStateAvailability",
    "OAuthTokens",
    "AdvisorAttributes",
    "PolicyApplicationForms",
    "ClientPolicyApplications",
    "ClientPolicyApplicationForms",
    "ClientPolicyApplicationSteps",
    "ClientPolicyApplicationConsents",
    "Consents",
    "ConsentRecords",
    "DeletedClientsConsents",
    "DocuSignPolicyApplicationEnvelopes",
    "AdvisorOrganizations",
    "TraditionalLTCQuotes",
    "TraditionalLTCQuoteStateAvailability",
    "AdvisorAddresses",
    "PolicyApplicationRemarksOverflow",
    "AdvisorBgaCarrierLinks",
    "AdvisorCarrierPolicyTypes",
    "DeletedClients",
    "ZipCareCosts",
    "ClientPolicyConsentNotificationLogs",
    "CommunicationLogs",
    "GenworthSftpLogs",
    "ClientEligibleQuotes",
    "ClientEligibleTraditionalLTCQuotes",
    "ClientQuoteProjections",
    "InsuranceCarrierProducts",
    "DocusignTemplates",
    "PolicyApplicationFormTemplates",
    "PolicyApplicationFormSections",
    "PolicyApplicationFormQuestionGroups",
    "PolicyApplicationFormQuestions",
    "InsuranceCarrierProductPolicyApplicationForms",
    "UserOnboardingEngagementLogs",
    "PolicyApplicationTemplateConfiguration",
    "AdvisorOnboardingCompletedSteps",
    "Events"
  ],
  "fieldsByName": {},
  "tableNames": {
    "advisorAddresses": "AdvisorAddresses",
    "advisorAttributes": "AdvisorAttributes",
    "advisorBgaCarrierLinks": "AdvisorBgaCarrierLinks",
    "advisorCarrierPolicyTypes": "AdvisorCarrierPolicyTypes",
    "advisorConsents": "AdvisorConsents",
    "advisorHierarchy": "AdvisorHierarchy",
    "advisorOnboardingCompletedSteps": "AdvisorOnboardingCompletedSteps",
    "advisorOrganizations": "AdvisorOrganizations",
    "advisorReferralSources": "AdvisorReferralSources",
    "advisorSettings": "AdvisorSettings",
    "advisorSponsorshipActivities": "AdvisorSponsorshipActivities",
    "advisorSponsorshipStatuses": "AdvisorSponsorshipStatuses",
    "advisorSponsorships": "AdvisorSponsorships",
    "advisorStripeSubscriptions": "AdvisorStripeSubscriptions",
    "advisors": "Advisors",
    "annuityTypes": "AnnuityTypes",
    "careEnvironmentSelections": "CareEnvironmentSelections",
    "careEnvironments": "CareEnvironments",
    "carePhases": "CarePhases",
    "clientAuthUsers": "ClientAuthUsers",
    "clientCalculationSettings": "ClientCalculationSettings",
    "clientCalculations": "ClientCalculations",
    "clientCareEnvironmentCosts": "ClientCareEnvironmentCosts",
    "clientCarePhaseDurationSelections": "ClientCarePhaseDurationSelections",
    "clientCustomInferences": "ClientCustomInferences",
    "clientEligibleQuotes": "ClientEligibleQuotes",
    "clientEligibleTraditionalLtcQuotes": "ClientEligibleTraditionalLTCQuotes",
    "clientEmailEngagements": "ClientEmailEngagements",
    "clientOnboardingSlideProgress": "ClientOnboardingSlideProgress",
    "clientPartnerLinks": "ClientPartnerLinks",
    "clientPolicyApplicationConsents": "ClientPolicyApplicationConsents",
    "clientPolicyApplicationForms": "ClientPolicyApplicationForms",
    "clientPolicyApplicationSteps": "ClientPolicyApplicationSteps",
    "clientPolicyApplications": "ClientPolicyApplications",
    "clientPolicyConsentNotificationLogs": "ClientPolicyConsentNotificationLogs",
    "clientPolicyDataExtractRequests": "ClientPolicyDataExtractRequests",
    "clientQuoteProjections": "ClientQuoteProjections",
    "clientReferralSources": "ClientReferralSources",
    "clientRelationshipStages": "ClientRelationshipStages",
    "clientStatuses": "ClientStatuses",
    "clientTagDefs": "ClientTagDefs",
    "clientTags": "ClientTags",
    "clients": "Clients",
    "communicationLogs": "CommunicationLogs",
    "consentRecords": "ConsentRecords",
    "consents": "Consents",
    "deletedClients": "DeletedClients",
    "deletedClientsConsents": "DeletedClientsConsents",
    "docuSignPolicyApplicationEnvelopes": "DocuSignPolicyApplicationEnvelopes",
    "docusignTemplates": "DocusignTemplates",
    "emailPreferences": "EmailPreferences",
    "emailTransactionLog": "EmailTransactionLog",
    "events": "Events",
    "fundingPolicyTypes": "FundingPolicyTypes",
    "fundingSourceDetails": "FundingSourceDetails",
    "fundingSources": "FundingSources",
    "genworthSftpLogs": "GenworthSftpLogs",
    "illustrationRequests": "IllustrationRequests",
    "inferenceSets": "InferenceSets",
    "insuranceCarrierProductPolicyApplicationForms": "InsuranceCarrierProductPolicyApplicationForms",
    "insuranceCarrierProducts": "InsuranceCarrierProducts",
    "insuranceCarriers": "InsuranceCarriers",
    "insuranceQuotes": "InsuranceQuotes",
    "intakeFormPayloads": "IntakeFormPayloads",
    "formProviderReferences": "FormProviderReferences",
    "magicLinkVerificationCodes": "MagicLinkVerificationCodes",
    "magicLinks": "MagicLinks",
    "oAuthTokens": "OAuthTokens",
    "openAiCompletionRequests": "OpenAiCompletionRequests",
    "partnerLinkRequests": "PartnerLinkRequests",
    "policyApplicationFormQuestionGroups": "PolicyApplicationFormQuestionGroups",
    "policyApplicationFormQuestions": "PolicyApplicationFormQuestions",
    "policyApplicationFormSections": "PolicyApplicationFormSections",
    "policyApplicationFormTemplates": "PolicyApplicationFormTemplates",
    "policyApplicationForms": "PolicyApplicationForms",
    "policyApplicationRemarksOverflow": "PolicyApplicationRemarksOverflow",
    "policyApplicationTemplateConfiguration": "PolicyApplicationTemplateConfiguration",
    "quoteStateAvailability": "QuoteStateAvailability",
    "quotes": "Quotes",
    "sponsorshipActivities": "SponsorshipActivities",
    "sponsorshipActivityTypes": "SponsorshipActivityTypes",
    "sponsorships": "Sponsorships",
    "stripeCustomer": "StripeCustomer",
    "stripeSubscriptions": "StripeSubscriptions",
    "subscriptionSeats": "SubscriptionSeats",
    "supportProviderContributions": "SupportProviderContributions",
    "supportProviderDetailSetSources": "SupportProviderDetailSetSources",
    "supportProviderDetailSets": "SupportProviderDetailSets",
    "supportProviderDetails": "SupportProviderDetails",
    "supportProviderTypes": "SupportProviderTypes",
    "supportProviders": "SupportProviders",
    "surveyAnswers": "SurveyAnswers",
    "surveyDefinitions": "SurveyDefinitions",
    "surveyQuestionTypes": "SurveyQuestionTypes",
    "surveyQuestions": "SurveyQuestions",
    "surveyStatuses": "SurveyStatuses",
    "surveySubmitters": "SurveySubmitters",
    "surveys": "Surveys",
    "traditionalLtcQuoteStateAvailability": "TraditionalLTCQuoteStateAvailability",
    "traditionalLtcQuotes": "TraditionalLTCQuotes",
    "userOnboardingEngagementLogs": "UserOnboardingEngagementLogs",
    "walpSchemaVersion": "WalpSchemaVersion",
    "zipCareCosts": "ZipCareCosts"
  }
};

// create title case references to table and field names as well
function copyToUpperFirstKey<T>(map: ObjectMap<T>) {
  Object.entries(map).forEach(copyToUpperFirstKeyIterator);

  function copyToUpperFirstKeyIterator([name, def]: [string, T]) {
    return (map[upperFirst(name)] = def);
  }
};
copyToUpperFirstKey(appModel.tablesByName);
copyToUpperFirstKey(appModel.fieldsByName);

// populate fieldsByName
{
  const fieldsByName = appModel.fieldsByName as ObjectMap<AppFieldDef>;
  Object.values(appModel.tablesByName)
    .forEach(
      (tableDef) => {
        Object.entries(tableDef.fields as ObjectMap<AppFieldDef>).forEach(
          ([ fieldName, fieldDef ]: [ string, AppFieldDef ]) => {
            if (fieldDef.referenceTableName) {
              return;
            }
            fieldsByName[ fieldName ] = fieldDef;
          });
      });
}

export enum CareEnvironment {
  home = 2701,
  independentLiving = 2703,
  assistedLiving = 2704,
  fullCareFacility = 2705,
}

export enum CarePhase {
  earlyCare = 2801,
  moderateCare = 2802,
  fullCare = 2803,
}

export enum ClientStatus {
  active = 1101,
  inactive = 1102,
  archived = 1103,
}

export enum ClientTagDef {
  fillOutTheIntakeForm = 1201,
  algorithmsCurrentlyRunning = 1202,
  algorithmsFinishedRunning = 1203,
  startOnboarding = 1204,
  closingTheCareGap = 1205,
  updateYourCareSupportStructure = 1206,
  completedPlan = 1207,
  algorithmsError = 1208,
  clientStartedReview = 1209,
  clientCompletedReview = 1210,
  reviewCallScheduled = 1211,
  reviewStartedTogether = 1212,
  reviewCompletedTogether = 1213,
  intakeFormIncomplete = 1214,
  startedIntakeForm = 1215,
  requestedMeeting = 1216,
  representativeAssigned = 1217,
  initialContactMade = 1218,
}

export enum FundingPolicyType {
  longTermCareInsurance = 2901,
  lifeInsuranceWithRider = 2902,
  hybridLifeInsurance = 2903,
  shortTermCareInsurance = 2904,
  annuityHybrid = 2905,
  jointHybridAssetBased = 2906,
  jointHybridAnnuityBased = 2907,
  lifeWithIndexAccount = 2908,
  allstateHybridPolicy = 2909,
  hybridLifeIra = 2910,
  jointHybridLifeIra = 2911,
  fortifiedLife = 2912,
  nylSecureCare = 2913,
  nylAssetFlex = 2914,
  nylJointSecureCare = 2915,
  secureCareThree = 2916,
  moneyGuardFixedAdvantage = 2917,
  assetCare = 2918,
  careMattersTwo = 2919,
  jointAssetCare = 2920,
  jointCareMatters = 2921,
  forecareFixedAnnuity = 2922,
  annuityCareTwo = 2923,
  jointForecareFixedAnnuity = 2924,
  assetcareThree = 2925,
  jointAssetcareThree = 2926,
  noLapseGuaranteeLife = 2927,
  jointLongTermCareInsurance = 2928,
  thriventLongTermCareInsurance = 2929,
  jointThriventLongTermCareInsurance = 2930,
  nglEssentialLtc = 2931,
  jointNglEssentialLtc = 2932,
  mutualOfOmahaMutualcare = 2933,
  jointMutualOfOmahaMutualcare = 2934,
  agisGroupPolicy = 2935,
  careScoutCareAssurance = 2936,
  unknownPolicyType = 2937,
  indexedAnnuityCare = 2938,
}

export enum AnnuityType {
  basicAnnuity = 3001,
}

export enum SupportProviderContribution {
  physicalCaregiver = 2601,
  careCoordinator = 2602,
  financialCaregiver = 2603,
}

export enum SupportProviderDetailSetSource {
  inferences = 2101,
  client = 2102,
}

export enum SupportProviderType {
  self = 2200,
  professional = 2201,
  spouse = 2202,
  other = 2203,
  child = 2204,
}

export enum SurveyQuestionType {
  text = 2501,
  date = 2502,
  integer = 2503,
  multipleChoice = 2505,
  manyMultipleChoice = 2506,
  ranking = 2507,
  boolean = 2508,
  phoneNumber = 2509,
  email = 2510,
}

export enum SurveyStatus {
  incomplete = 2301,
  complete = 2302,
  abandoned = 2303,
}

export enum SurveySubmitter {
  advisor = 2401,
  client = 2402,
  supportProvider = 2403,
}

export enum SponsorshipActivityType {
  clientsAdded = 4001,
}

export enum AdvisorSponsorshipStatus {
  active = 4101,
  inactive = 4102,
  invited = 4103,
}

export const surveyQuestionTypeByQuestionRef: ObjectMap<SurveyQuestionType> = {
  clientMaritalStatus: SurveyQuestionType.multipleChoice,
  partnerFirstName: SurveyQuestionType.text,
  partnerLastName: SurveyQuestionType.text,
  householdPartnered: SurveyQuestionType.multipleChoice,
  householdHouseholdSize: SurveyQuestionType.integer,
  clientBirthDate: SurveyQuestionType.date,
  clientGenderIdentity: SurveyQuestionType.manyMultipleChoice,
  clientGenderAtBirth: SurveyQuestionType.multipleChoice,
  clientRace: SurveyQuestionType.multipleChoice,
  clientZipCode: SurveyQuestionType.text,
  clientCensusRegion: SurveyQuestionType.multipleChoice,
  clientHighestDegree: SurveyQuestionType.multipleChoice,
  clientLivingSiblingsCount: SurveyQuestionType.integer,
  householdLivingChildrenCount: SurveyQuestionType.integer,
  householdPriorYearIncome: SurveyQuestionType.integer,
  householdTotalAssetsValue: SurveyQuestionType.integer,
  financialAssetTypes: SurveyQuestionType.manyMultipleChoice,
  legalDocuments: SurveyQuestionType.manyMultipleChoice,
  clientHealthPlanList: SurveyQuestionType.manyMultipleChoice,
  clientIndependencePreference: SurveyQuestionType.multipleChoice,
  clientFinancialSecurityPreference: SurveyQuestionType.multipleChoice,
  clientFamilyInvolvementPreference: SurveyQuestionType.multipleChoice,
  clientMentalHealthIssuesList: SurveyQuestionType.manyMultipleChoice,
  clientSmokerEver: SurveyQuestionType.multipleChoice,
  clientSmokedRecently: SurveyQuestionType.multipleChoice,
  clientUsesRegularPrescriptionDrugs: SurveyQuestionType.multipleChoice,
  clientWeightPounds: SurveyQuestionType.integer,
  clientHeightInches: SurveyQuestionType.integer,
  clientPriorTwoYearHospitalizationCount: SurveyQuestionType.integer,
  clientActivitiesWithDifficultyList: SurveyQuestionType.manyMultipleChoice,
  clientActivitiesReceivedAssistanceList: SurveyQuestionType.manyMultipleChoice,
  clientAgeReceivedHelpBathing: SurveyQuestionType.integer,
  clientAgeReceivedHelpEating: SurveyQuestionType.integer,
  clientAgeReceivedHelpDressing: SurveyQuestionType.integer,
  clientAgeReceivedHelpWalking: SurveyQuestionType.integer,
  clientAgeReceivedHelpAccessingBed: SurveyQuestionType.integer,
  clientAgeReceivedHelpToileting: SurveyQuestionType.integer,
  clientDiagnosesList: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesList: SurveyQuestionType.manyMultipleChoice,
  clientCanAnswerForFather: SurveyQuestionType.boolean,
  clientFatherIsAlive: SurveyQuestionType.multipleChoice,
  clientFatherAgeAtSurveyDate: SurveyQuestionType.integer,
  clientFatherAgeOfDeathAtSurveyDate: SurveyQuestionType.integer,
  clientFatherRequiredAssistance: SurveyQuestionType.multipleChoice,
  clientFatherAssistanceDurationMonthCount: SurveyQuestionType.integer,
  clientFatherNursingHomeEver: SurveyQuestionType.multipleChoice,
  clientFatherNursingHomeMonthCount: SurveyQuestionType.integer,
  clientFatherCardiovascularEver: SurveyQuestionType.multipleChoice,
  clientFatherMemoryProblemsEver: SurveyQuestionType.multipleChoice,
  clientFatherMemoryDiagnosesList: SurveyQuestionType.manyMultipleChoice,
  clientCanAnswerForMother: SurveyQuestionType.boolean,
  clientMotherIsAlive: SurveyQuestionType.multipleChoice,
  clientMotherAgeAtSurveyDate: SurveyQuestionType.integer,
  clientMotherAgeOfDeathAtSurveyDate: SurveyQuestionType.integer,
  clientMotherRequiredAssistance: SurveyQuestionType.multipleChoice,
  clientMotherAssistanceDurationMonthCount: SurveyQuestionType.integer,
  clientMotherNursingHomeEver: SurveyQuestionType.multipleChoice,
  clientMotherNursingHomeMonthCount: SurveyQuestionType.integer,
  clientMotherCardiovascularEver: SurveyQuestionType.multipleChoice,
  clientMotherMemoryProblemsEver: SurveyQuestionType.multipleChoice,
  clientMotherMemoryDiagnosesList: SurveyQuestionType.manyMultipleChoice,
  clientHospitalizedERLastTwelveMonths: SurveyQuestionType.manyMultipleChoice,
  clientMedicationIntake: SurveyQuestionType.text,
  clientTherapyTypes: SurveyQuestionType.manyMultipleChoice,
  clientMarijuanaLastFiveYears: SurveyQuestionType.integer,
  clientHardDrugsLastFiveYears: SurveyQuestionType.integer,
  clientAssistiveDevicesList: SurveyQuestionType.manyMultipleChoice,
  clientSubstancesUsed: SurveyQuestionType.manyMultipleChoice,
  clientWeightGainedLost: SurveyQuestionType.multipleChoice,
  clientWeightGainedLastTwelveMonths: SurveyQuestionType.integer,
  clientWeightLostLastTwelveMonths: SurveyQuestionType.integer,
  clientHospitalizationReason: SurveyQuestionType.text,
  clientBloodPressureReading: SurveyQuestionType.multipleChoice,
  clientHeartConditionDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientDiabetesTypeDiagnosisList: SurveyQuestionType.multipleChoice,
  clientLastA1CReading: SurveyQuestionType.multipleChoice,
  clientMetabolicDisordersList: SurveyQuestionType.manyMultipleChoice,
  clientLungRespiratoryDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientDigestiveDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientBrainInjuryDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientCognitiveMemoryDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientPsychiatricDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientCancerTypeLocation: SurveyQuestionType.text,
  clientEENTDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientGenitourinaryDiagnosis: SurveyQuestionType.manyMultipleChoice,
  clientImmuneSystemDiagnosis: SurveyQuestionType.multipleChoice,
  clientDisabilityWorkersComp: SurveyQuestionType.multipleChoice,
  clientCigaretteLastFiveYears: SurveyQuestionType.integer,
  clientCigarPipeLastFiveYears: SurveyQuestionType.integer,
  clientVapeLastFiveYears: SurveyQuestionType.integer,
  clientChewTobaccoLastFiveYears: SurveyQuestionType.integer,
  clientAlcoholLastFiveYears: SurveyQuestionType.integer,
  clientMedicaidProgramName: SurveyQuestionType.text,
  clientInjuryArthritis: SurveyQuestionType.multipleChoice,
  financialSecurityPreference: SurveyQuestionType.multipleChoice,
  independenceandQualityofLifePreference: SurveyQuestionType.multipleChoice,
  careEnvironmentPreference: SurveyQuestionType.multipleChoice,
  familyInvolvementPreference: SurveyQuestionType.multipleChoice,
  riskAssessmentPreference: SurveyQuestionType.multipleChoice,
  flexibilityPreference: SurveyQuestionType.multipleChoice,
  costEffectivenessPreference: SurveyQuestionType.multipleChoice,
  clientOwnPersonalityPerceptions: SurveyQuestionType.manyMultipleChoice,
  stressManagementPreference: SurveyQuestionType.multipleChoice,
  disagreementResolutionPreference: SurveyQuestionType.multipleChoice,
  supportProviderInvolvement: SurveyQuestionType.multipleChoice,
  rankedFactors: SurveyQuestionType.ranking,
  incentiveToAcceptCare: SurveyQuestionType.multipleChoice,
  willingnessToAcceptCare: SurveyQuestionType.multipleChoice,
  trustLevel: SurveyQuestionType.multipleChoice,
  currentCommunnicationFrequency: SurveyQuestionType.multipleChoice,
  emotionalCloseness: SurveyQuestionType.multipleChoice,
  rolePreference: SurveyQuestionType.multipleChoice,
  willingnessToReceiveCare: SurveyQuestionType.multipleChoice,
  clientFinancialStability: SurveyQuestionType.multipleChoice,
  previousExperience: SurveyQuestionType.multipleChoice,
  potentialSupportProvider: SurveyQuestionType.manyMultipleChoice,
  relationshipCloseness: SurveyQuestionType.multipleChoice,
  relationshipChangeComfortLevel: SurveyQuestionType.multipleChoice,
  financialNeedConcernLevel: SurveyQuestionType.multipleChoice,
  receivingCareInterferenceLikelihood: SurveyQuestionType.multipleChoice,
  physicalStressLevel: SurveyQuestionType.multipleChoice,
  emotionalStressLevel: SurveyQuestionType.multipleChoice,
  preferredSupportServices: SurveyQuestionType.manyMultipleChoice,
  endOfLifeComfortLevel: SurveyQuestionType.multipleChoice,
  clientDecisionMakingInvolvement: SurveyQuestionType.multipleChoice,
  setbackImpactLevel: SurveyQuestionType.multipleChoice,
  clientPreparednessForDurationLevel: SurveyQuestionType.multipleChoice,
  financialResponsibilityHandoverPreparedness: SurveyQuestionType.multipleChoice,
  stressCopingEffectivness: SurveyQuestionType.multipleChoice,
  consideredImpactOnOtherRelationships: SurveyQuestionType.multipleChoice,
  personalCareTaskComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderPersonality: SurveyQuestionType.multipleChoice,
  supportProviderStressCopingPreference: SurveyQuestionType.multipleChoice,
  supportProviderRelationshipWithClient: SurveyQuestionType.multipleChoice,
  supportProviderConflictResolutionWithCareRecipientPreferences: SurveyQuestionType.multipleChoice,
  supportProviderToClientTrustLevel: SurveyQuestionType.multipleChoice,
  supportProviderCommunicationFrequency: SurveyQuestionType.multipleChoice,
  supportProviderEmotionalClosenessLevel: SurveyQuestionType.multipleChoice,
  supportProviderRolePreference: SurveyQuestionType.multipleChoice,
  supportProviderFactorPrioritization: SurveyQuestionType.ranking,
  supportProviderValidCircumstancePreferences: SurveyQuestionType.multipleChoice,
  supportProviderCareWillingnessCapabilitiyComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderFinancialStabilityLevel: SurveyQuestionType.multipleChoice,
  supportProviderExperienceLevel: SurveyQuestionType.multipleChoice,
  supportProviderSupportNetwork: SurveyQuestionType.manyMultipleChoice,
  supportProviderRelationshipToCareRecipient: SurveyQuestionType.multipleChoice,
  supportProviderHoursPerWeek: SurveyQuestionType.multipleChoice,
  supportProviderRelationshipForecast: SurveyQuestionType.multipleChoice,
  supportProviderEmotionalStrainForecast: SurveyQuestionType.multipleChoice,
  supportProviderFinancialWorryLevel: SurveyQuestionType.multipleChoice,
  supportProviderCareInterferenceLevel: SurveyQuestionType.multipleChoice,
  supportProviderPhysicalStressLevel: SurveyQuestionType.multipleChoice,
  supportProviderEmotionalStressLevel: SurveyQuestionType.multipleChoice,
  supportProviderDependentFamilyLevel: SurveyQuestionType.multipleChoice,
  supportProviderChronicHealthIssueLevel: SurveyQuestionType.multipleChoice,
  supportProviderMedicalFamiliarityLevel: SurveyQuestionType.multipleChoice,
  supportProviderTrainingComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderSupportServiceComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderEndOfLiveComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderDecisionMakingVoiceLevel: SurveyQuestionType.multipleChoice,
  supportProviderSetbackComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderDurationComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderFinancialResponsibilityComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderAppreciationComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderOverwhelmPreferences: SurveyQuestionType.multipleChoice,
  supportProviderImpactToOtherRelationshipsComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderPersonalCareTasksComfortLevel: SurveyQuestionType.multipleChoice,
  supportProviderHealthcareNavigationComfortLevel: SurveyQuestionType.multipleChoice,
  consentToTermsOfService: SurveyQuestionType.multipleChoice,
  respondentRelationToClient: SurveyQuestionType.multipleChoice,
  respondentRelationToClientSelfOrSpouse: SurveyQuestionType.multipleChoice,
  hasLongTermCareInsurance: SurveyQuestionType.multipleChoice,
  hasLongTermCareInsuranceProxy: SurveyQuestionType.multipleChoice,
  clientFirstName: SurveyQuestionType.multipleChoice,
  clientLastName: SurveyQuestionType.multipleChoice,
  clientEmail: SurveyQuestionType.multipleChoice,
  clientPhoneNumber: SurveyQuestionType.multipleChoice,
  proxyFirstName: SurveyQuestionType.multipleChoice,
  proxyLastName: SurveyQuestionType.multipleChoice,
  proxyEmail: SurveyQuestionType.multipleChoice,
  proxyPhoneNumber: SurveyQuestionType.multipleChoice,
  clientMarijuanaUsageType: SurveyQuestionType.multipleChoice,
  clientMedicalMarijuanaCondition: SurveyQuestionType.text,
  clientMushroomLastFiveYears: SurveyQuestionType.integer,
  clientMedChangeLastTwelveMonths: SurveyQuestionType.multipleChoice,
  clientMedChangeDescLastTwelveMonths: SurveyQuestionType.text,
  clientMedChangeCauseLastTwelveMonths: SurveyQuestionType.text,
  clientPhysicalTherapyTense: SurveyQuestionType.multipleChoice,
  clientPhysicalTherapyFrequency: SurveyQuestionType.multipleChoice,
  clientPhysicalTherapyEnd: SurveyQuestionType.text,
  clientPhysicalTherapyReason: SurveyQuestionType.text,
  clientOccupationalTherapyTense: SurveyQuestionType.multipleChoice,
  clientOccupationalTherapyFrequency: SurveyQuestionType.multipleChoice,
  clientOccupationalTherapyEnd: SurveyQuestionType.text,
  clientOccupationalTherapyReason: SurveyQuestionType.text,
  clientChiropracticTherapyTense: SurveyQuestionType.multipleChoice,
  clientChiropracticTherapyFrequency: SurveyQuestionType.multipleChoice,
  clientChiropracticTherapyEnd: SurveyQuestionType.text,
  clientChiropracticTherapyReason: SurveyQuestionType.text,
  clientPriorTwoYearERCount: SurveyQuestionType.integer,
  clientERReason: SurveyQuestionType.text,
  clientAgeReceivedHelpClimbingStairs: SurveyQuestionType.integer,
  clientAgeReceivedHelpShopping: SurveyQuestionType.integer,
  clientAgeReceivedHelpTakingMedication: SurveyQuestionType.integer,
  clientAgeReceivedHelpPreparingMeals: SurveyQuestionType.integer,
  clientAgeReceivedHelpManagingFinances: SurveyQuestionType.integer,
  clientAgeReceivedHelpMakingPhoneCalls: SurveyQuestionType.integer,
  clientHighBloodPressureYear: SurveyQuestionType.text,
  clientHighBloodPressureControlled: SurveyQuestionType.manyMultipleChoice,
  clientHeartConditionDiagnosisYear: SurveyQuestionType.text,
  clientHeartConditionDiagnosisTreatment: SurveyQuestionType.manyMultipleChoice,
  clientDiabetesDiagnosisYear: SurveyQuestionType.text,
  clientDiabetesControlMethod: SurveyQuestionType.manyMultipleChoice,
  clientMetabolicDisorderYear: SurveyQuestionType.text,
  clientMetabolicDisorderControlled: SurveyQuestionType.manyMultipleChoice,
  clientLungRespiratoryYear: SurveyQuestionType.text,
  clientLungRespiratoryTreatment: SurveyQuestionType.manyMultipleChoice,
  clientDigestiveYear: SurveyQuestionType.text,
  clientBrainInjuryLastEpisodeYear: SurveyQuestionType.text,
  clientBrainInjuryLimitations: SurveyQuestionType.manyMultipleChoice,
  clientCognitiveMemoryYear: SurveyQuestionType.text,
  clientCognitiveMemorySeverity: SurveyQuestionType.multipleChoice,
  clientPsychiatricYear: SurveyQuestionType.text,
  clientCancerYear: SurveyQuestionType.text,
  clientCancerStage: SurveyQuestionType.text,
  clientCancerTreatment: SurveyQuestionType.manyMultipleChoice,
  clientCancerTreatmentDate: SurveyQuestionType.text,
  clientCancerRecurrenceSpread: SurveyQuestionType.text,
  clientEENTDYear: SurveyQuestionType.text,
  clientEENTDSurgery: SurveyQuestionType.multipleChoice,
  clientEENTDSurgeryType: SurveyQuestionType.text,
  clientEENTDLimits: SurveyQuestionType.multipleChoice,
  clientGenitourinaryYear: SurveyQuestionType.text,
  clientImmuneSystemYear: SurveyQuestionType.text,
  clientInjuriesKnee: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesKneeYear: SurveyQuestionType.text,
  clientInjuriesKneeSurgeryYear: SurveyQuestionType.text,
  clientInjuriesKneeSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesAnkle: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesAnkleYear: SurveyQuestionType.text,
  clientInjuriesAnkleSurgeryYear: SurveyQuestionType.text,
  clientInjuriesAnkleSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesHip: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesHipYear: SurveyQuestionType.text,
  clientInjuriesHipSurgeryYear: SurveyQuestionType.text,
  clientInjuriesHipSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesBack: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesBackYear: SurveyQuestionType.text,
  clientInjuriesBackSurgeryYear: SurveyQuestionType.text,
  clientInjuriesBackSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesShoulder: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesShoulderYear: SurveyQuestionType.text,
  clientInjuriesShoulderSurgeryYear: SurveyQuestionType.text,
  clientInjuriesShoulderSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesNeck: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesNeckYear: SurveyQuestionType.text,
  clientInjuriesNeckSurgeryYear: SurveyQuestionType.text,
  clientInjuriesNeckSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesWrist: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesWristYear: SurveyQuestionType.text,
  clientInjuriesWristSurgeryYear: SurveyQuestionType.text,
  clientInjuriesWristSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesElbow: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesElbowYear: SurveyQuestionType.text,
  clientInjuriesElbowSurgeryYear: SurveyQuestionType.text,
  clientInjuriesElbowSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuriesFoot: SurveyQuestionType.manyMultipleChoice,
  clientInjuriesFootYear: SurveyQuestionType.text,
  clientInjuriesFootSurgeryYear: SurveyQuestionType.text,
  clientInjuriesFootSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuryJoints: SurveyQuestionType.manyMultipleChoice,
  clientInjuryJointsYear: SurveyQuestionType.text,
  clientInjuryJointsSurgeryYear: SurveyQuestionType.text,
  clientInjuryJointsSurgeryPlanned: SurveyQuestionType.multipleChoice,
  clientInjuryJointInjectionLastTwelveMonths: SurveyQuestionType.multipleChoice,
  clientInjuryAdditionalDetails: SurveyQuestionType.text,
  clientUndiagnosedCondition: SurveyQuestionType.multipleChoice,
  clientLastDoctorVisitYear: SurveyQuestionType.integer,
  clientAdditionalMedicalHistory: SurveyQuestionType.text,
  clientLtcZipCode: SurveyQuestionType.text,
  clientOtherHealthPlanList: SurveyQuestionType.manyMultipleChoice,
  clientProfessionalSupportNetworkList: SurveyQuestionType.manyMultipleChoice,
};
